{
  "common": {
    "loading": "Cargando...",
    "error": "Error",
    "retry": "Reintentar",
    "cancel": "Cancelar",
    "save": "Guardar",
    "saving": "Guardando...",
    "close": "Cerrar",
    "back": "Volver",
    "next": "Siguiente",
    "search": "Buscar",
    "watchNow": "Ver Ahora",
    "playNow": "Reproducir",
    "play": "Reproducir",
    "moreInfo": "Más Información",
    "seeAll": "Ver Todo",
    "new": "Nuevo",
    "live": "En Vivo",
    "recommended": "Recomendado",
    "edit": "Editar",
    "delete": "Eliminar",
    "add": "Agregar",
    "enabled": "Habilitado",
    "disabled": "Deshabilitado",
    "invalidDate": "Fecha inválida",
    "appName": "🏠 Bayit+",
    "appVersion": "🏠 Bayit+ v1.0.0",
    "slogan": "Tu Casa. En Todas Partes.",
    "ok": "Aceptar",
    "success": "Éxito",
    "warning": "Advertencia",
    "confirm": "Confirmar",
    "yes": "Sí",
    "no": "No",
    "apply": "Aplicar",
    "errors": {
      "unexpected": "Ocurrió un error inesperado"
    },
    "send": "Enviar",
    "done": "Hecho",
    "all": "Todo",
    "reset": "Restablecer",
    "deleting": "Eliminando...",
    "noResults": "No se encontraron resultados",
    "tryDifferentSearch": "Prueba con otro término de búsqueda",
    "previous": "Anterior",
    "actions": "Acciones",
    "pageOf": "Página {{page}} de {{total}}",
    "noData": "No hay datos disponibles",
    "filters": "Filtros",
    "clear": "Limpiar",
    "clearSelection": "Limpiar",
    "expand": "Expandir",
    "collapse": "Contraer",
    "upgrade": "Actualizar a Premium",
    "skip": "Omitir",
    "thisContent": "este contenido",
    "backToHome": "Volver al inicio",
    "dismiss": "Descartar",
    "goBack": "Volver",
    "pause": "Pausar",
    "tryAgain": "Reintentar",
    "refresh": "Actualizar"
  },
  "culturalContext": {
    "loading": "Cargando explicación...",
    "loadError": "Error al cargar la explicación",
    "related": "Referencias relacionadas"
  },
  "demo": {
    "banner": "MODO DEMOSTRACIÓN",
    "bannerSubtext": "Usando datos simulados - Sin llamadas API",
    "days": {
      "sunday": "Domingo",
      "monday": "Lunes",
      "tuesday": "Martes",
      "wednesday": "Miércoles",
      "thursday": "Jueves",
      "friday": "Viernes",
      "saturday": "Sábado"
    },
    "shabbat": "Sábado",
    "until_shabbat": "Hasta Sábado",
    "search_interpretation": "Buscar \"{{query}}\"",
    "suggestions": {
      "0": "Fauda",
      "1": "Shtisel",
      "2": "Teherán",
      "3": "El Árbitro",
      "4": "Labor Árabe"
    },
    "premium_plan": "Premium",
    "assistant_response": "¡Te recomiendo Fauda - una excelente serie de suspenso!",
    "morning_greeting": "¡Buenos días! Hoy hace buen clima, hay algunas noticias importantes de Israel, y he seleccionado contenido especialmente para ti."
  },
  "hero": {
    "watch": "Ver",
    "moreInfo": "Más Información",
    "addToList": "Agregar a Lista"
  },
  "login": {
    "title": "Bienvenido de Nuevo",
    "subtitle": "Inicia sesión para continuar en Bayit+",
    "tagline": "Tu Hogar en EE.UU.",
    "email": "Correo",
    "emailPlaceholder": "Ingresa tu correo",
    "password": "Contraseña",
    "passwordPlaceholder": "Ingresa tu contraseña",
    "submit": "Iniciar Sesión",
    "loggingIn": "Iniciando sesión...",
    "or": "o",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "continueWithGoogle": "Continuar con Google",
    "noAccount": "¿No tienes una cuenta?",
    "signUp": "Regístrate",
    "register": "Registrarse",
    "name": "Nombre",
    "termsNotice": "Al iniciar sesión, aceptas nuestros Términos de Servicio y Política de Privacidad",
    "errors": {
      "emailRequired": "El correo es requerido",
      "passwordRequired": "La contraseña es requerida",
      "loginFailed": "Error al iniciar sesión. Verifica tus credenciales.",
      "googleFailed": "Error al iniciar sesión con Google. Intenta de nuevo.",
      "fillAllFields": "Por favor, completa todos los campos"
    },
    "qrInstructions": "Escanea el código con tu teléfono para acceso rápido",
    "methodQR": "Código QR",
    "methodVoice": "Voz",
    "methodTraditional": "Correo",
    "qrTitle": "Escanea para Iniciar Sesión",
    "qrDescription": "Escanea este código QR con tu teléfono para iniciar sesión sin escribir",
    "expiresIn": "Expira en 5 minutos",
    "companionConnected": "¡Teléfono conectado!",
    "authenticating": "Iniciando sesión...",
    "sessionExpired": "Sesión expirada",
    "refreshQR": "Generar Nuevo Código",
    "generatingQR": "Generando código QR...",
    "howItWorks": "¿Cómo funciona?",
    "step1": "Abre la cámara en tu teléfono",
    "step2": "Escanea el código QR arriba",
    "step3": "Inicia sesión en tu teléfono",
    "step4": "¡El TV inicia sesión automáticamente!",
    "voicePlaceholder": "Escribe tu respuesta...",
    "send": "Enviar",
    "createAccount": "Crear Cuenta",
    "bayitThinking": "Bayit está pensando...",
    "unexpectedError": "Ocurrió un error inesperado"
  },
  "tvLogin": {
    "invalidQR": "Código QR inválido. Escanea de nuevo desde tu TV.",
    "sessionInvalid": "Este código QR ha expirado. Genera uno nuevo en tu TV.",
    "verificationFailed": "Error al verificar. Intenta de nuevo.",
    "fillAllFields": "Por favor, completa todos los campos",
    "loginFailed": "Error al iniciar sesión. Verifica tus credenciales.",
    "notLoggedIn": "No has iniciado sesión en este dispositivo.",
    "enterCredentials": "Ingresa tus credenciales para autorizar tu TV.",
    "authFailed": "Error de autorización.",
    "verifying": "Verificando...",
    "verifyingDescription": "Conectando a tu TV...",
    "loginTitle": "Iniciar Sesión en tu TV",
    "loginDescription": "Ingresa tus credenciales para autorizar tu TV",
    "authorizing": "Autorizando...",
    "authorizingDescription": "Iniciando sesión en tu TV...",
    "authorizeTV": "Autorizar TV",
    "success": "¡Éxito!",
    "successDescription": "Tu TV está conectado. Puedes cerrar esta página.",
    "goToHome": "Ir al Inicio",
    "error": "Algo salió mal",
    "tryAgain": "Intentar de Nuevo",
    "securityNote": "Tus credenciales se envían de forma segura y nunca se almacenan en el TV.",
    "footer": "¿Tienes problemas? Asegúrate de haber escaneado un código QR nuevo desde tu TV.",
    "almostThere": "Casi listo!",
    "authenticating": "Autenticando...",
    "connected": "Conectado",
    "expired": "Codigo expirado",
    "expiredMessage": "Tu codigo ha expirado. Solicita uno nuevo.",
    "header": "Iniciar sesion en TV",
    "pleaseSignIn": "Inicia sesion en tu telefono o computadora",
    "signInButton": "Iniciar sesion",
    "signInToTV": "Iniciar sesion en TV",
    "subtitle": "Ingresa el codigo mostrado en tu TV",
    "tvSignedIn": "TV conectada exitosamente"
  },
  "googleLogin": {
    "cancelledError": "Inicio de sesión con Google cancelado",
    "missingCode": "Código de autenticación faltante",
    "loginError": "Error al iniciar sesión con Google",
    "redirecting": "Redirigiendo a la página de inicio de sesión...",
    "connecting": "Conectando con Google..."
  },
  "register": {
    "title": "Crear Cuenta",
    "subtitle": "Únete a Bayit+ para ver tu contenido favorito",
    "name": "Nombre Completo",
    "namePlaceholder": "Juan Pérez",
    "email": "Correo",
    "emailPlaceholder": "your@email.com",
    "password": "Contraseña",
    "passwordPlaceholder": "Al menos 8 caracteres",
    "confirmPassword": "Confirmar Contraseña",
    "confirmPasswordPlaceholder": "Ingresa tu contraseña nuevamente",
    "submit": "Registrarse",
    "registering": "Registrando...",
    "acceptTerms": "Estoy de acuerdo con los",
    "termsOfService": "Términos de Servicio",
    "and": "y la",
    "privacyPolicy": "Política de Privacidad",
    "continueWithGoogle": "Regístrate con Google",
    "haveAccount": "¿Ya tienes una cuenta?",
    "signIn": "Inicia Sesión",
    "fullName": "Nombre Completo",
    "loginLink": "Inicia Sesión",
    "placeholders": {
      "fullName": "Juan Pérez",
      "email": "your@email.com",
      "password": "Al menos 8 caracteres",
      "confirmPassword": "Ingresa tu contraseña nuevamente"
    },
    "errors": {
      "nameRequired": "El nombre es requerido",
      "emailRequired": "El correo es requerido",
      "passwordRequired": "La contraseña es requerida",
      "passwordTooShort": "La contraseña debe tener al menos 8 caracteres",
      "passwordMismatch": "Las contraseñas no coinciden",
      "acceptTerms": "Debes aceptar los Términos de Servicio y la Política de Privacidad",
      "fillAllFields": "Por favor completa todos los campos",
      "registrationFailed": "El registro falló. Intenta de nuevo.",
      "googleFailed": "El registro con Google falló. Intenta de nuevo."
    }
  },
  "nav": {
    "home": "Inicio",
    "vod": "VOD",
    "liveTV": "TV en Vivo",
    "epg": "Guía de TV",
    "radio": "Radio",
    "podcasts": "Podcasts",
    "flows": "Flujos",
    "judaism": "Judaísmo",
    "children": "Niños",
    "profile": "Perfil",
    "search": "Buscar",
    "settings": "Configuración",
    "favorites": "Favoritos",
    "watchlist": "Mi Lista",
    "downloads": "Descargas",
    "recordings": "Mis Grabaciones",
    "widgets": "Widgets",
    "help": "Ayuda y Soporte",
    "discover": "Descubrir",
    "account": "Cuenta",
    "subscribe": "Suscribir",
    "plans": "Planes",
    "admin": "Administración",
    "games": "Juegos",
    "friends": "Amigos",
    "glossary": "Glosario",
    "missions": "Misiones",
    "audiobooks": "Audiolibros",
    "playlist": "Lista de reproduccion",
    "zehAniHub": "Zeh Ani",
    "support": "Soporte",
    "discoverHub": "Descubrir IA",
    "listen": "Escuchar",
    "byoc": "Mis fuentes",
    "household": "Hogar",
    "messages": "Mensajes",
    "myContent": "Mi contenido",
    "social": "Social"
  },
  "epg": {
    "title": "Guía de TV",
    "subtitle": "Navega por la programación de TV en vivo",
    "gridView": "Vista de Cuadrícula",
    "listView": "Vista de Lista",
    "israelTime": "Hora de Israel",
    "localTime": "Hora Local",
    "il": "IL",
    "local": "Local",
    "jumpToNow": "Ir a Ahora",
    "goBack": "← {{hours}}h",
    "goForward": "{{hours}}h →",
    "toggleTimezone": "Cambiar Zona Horaria",
    "errorTitle": "Error al Cargar la Guía de TV",
    "errorLoading": "No se pudieron cargar los datos de la guía de TV",
    "noPrograms": "No se encontraron programas",
    "noChannels": "No hay canales disponibles",
    "recordProgram": "Grabar Programa",
    "channel": "Canal",
    "enableSubtitles": "Activar Subtítulos",
    "subtitleLanguage": "Idioma de Subtítulos",
    "storageEstimate": "Estimación de Almacenamiento",
    "availableSpace": "Espacio Disponible",
    "lowStorage": "Advertencia de Almacenamiento Bajo",
    "lowStorageMessage": "Se está quedando sin espacio de almacenamiento. Considere eliminar grabaciones antiguas.",
    "scheduleRecording": "Programar Grabación",
    "scheduledRecordingNotSupported": "Las grabaciones programadas aún no son compatibles. Solo están disponibles las grabaciones inmediatas.",
    "recordingFailed": "Error al iniciar/programar la grabación",
    "smartSearch": "Búsqueda Inteligente",
    "smartSearchSubtitle": "Haz preguntas en lenguaje natural",
    "smartSearchPlaceholder": "ej., Muéstrame todos los programas con la actriz Tali Sharon esta noche",
    "searchPlaceholder": "Buscar programas, canales, actores...",
    "premiumRequired": "Función Premium",
    "premiumRequiredMessage": "La Búsqueda Inteligente usa IA para entender tus preguntas. Actualiza a Premium para acceder a esta función.",
    "searchWithAI": "Buscar con IA",
    "searching": "Buscando...",
    "tryThese": "Prueba estos ejemplos",
    "exampleQuery1": "Muéstrame todos los programas con la actriz Tali Sharon esta noche",
    "exampleQuery2": "¿Qué programas de comedia se emiten esta semana?",
    "exampleQuery3": "Encuentra documentales sobre historia en Canal 11",
    "exampleQuery4": "Muéstrame todos los programas de noticias mañana por la mañana",
    "aiDisclaimer": "Impulsado por Claude AI. Los resultados pueden variar según la disponibilidad de datos del programa.",
    "interpretationTitle": "Lo que entendí",
    "noResultsFound": "No se encontraron programas que coincidan con tu consulta"
  },
  "home": {
    "continueWatching": "Continuar Viendo",
    "featuredContent": "Destacados",
    "liveTV": "TV en Vivo",
    "allChannels": "Todos los Canales",
    "liveChannels": "Canales en Vivo",
    "showOnlyWithSubtitles": "Mostrar solo con subtítulos",
    "israeliMovies": "Películas Israelíes",
    "israeli-movies": "Películas Israelíes",
    "israeli-series": "Series Israelíes",
    "action": "Acción y Suspenso",
    "comedy": "Comedia",
    "drama": "Drama",
    "documentaries": "Documentales",
    "loadingContent": "Cargando contenido...",
    "liveNow": "En Vivo",
    "trendingInIsrael": "Tendencias en Israel",
    "jerusalemConnection": "Conexión Jerusalén",
    "telAvivConnection": "Conexión Tel Aviv",
    "categories": "Categorías",
    "nearYou": "Israelíes Cerca de Ti",
    "betaExclusive": "Exclusivo Beta",
    "carousel": {
      "fauda": {
        "title": "Fauda",
        "subtitle": "Temporada 4 - Ahora en Streaming",
        "description": "La exitosa serie israelí regresa para una cuarta temporada llena de suspenso y acción"
      },
      "shtisel": {
        "title": "Shtisel",
        "subtitle": "Todas las Temporadas Disponibles",
        "description": "Sigue a la familia Shtisel en el barrio ultraortodoxo de Jerusalén"
      },
      "tehran": {
        "title": "Teherán",
        "subtitle": "Temporada 2",
        "description": "Una agente del Mossad en el corazón de Irán en una misión peligrosa"
      },
      "live": {
        "title": "En Vivo - Kan 11",
        "subtitle": "Ver Ahora",
        "description": "Noticias, actualidad y contenido de calidad"
      }
    },
    "enableLocation": "Activar ubicacion",
    "locationPermissionDeniedDescription": "Se denego el acceso a la ubicacion. Activalo en Ajustes para ver contenido cercano.",
    "locationPermissionDescription": "Permite acceso a la ubicacion para descubrir contenido cercano.",
    "openSettings": "Abrir ajustes"
  },
  "search": {
    "title": "Buscar",
    "subtitle": "Encuentra películas, series, canales, estaciones de radio y podcasts",
    "placeholder": "Buscar contenido...",
    "voicePlaceholder": "Habla ahora...",
    "searching": "Buscando...",
    "listening": "Escuchando...",
    "noResults": "Sin resultados",
    "noResultsHint": "Intenta con otras palabras o cambia los filtros",
    "tryDifferent": "Intenta con otros términos",
    "resultsFor": "resultados para",
    "resultsFound": "{{count}} resultados encontrados para \"{{query}}\"",
    "recentSearches": "Búsquedas Recientes",
    "clearAll": "Limpiar Todo",
    "trending": "Búsquedas Populares",
    "promptTitle": "¿Qué estás buscando?",
    "promptDescription": "Busca tu contenido favorito o usa la búsqueda por voz",
    "filters": {
      "all": "Todo",
      "vod": "Películas y Series",
      "live": "Canales",
      "radio": "Radio",
      "podcast": "Podcasts",
      "moviesAndSeries": "Películas y Series",
      "channels": "Canales",
      "podcasts": "Podcasts"
    },
    "suggestions": {
      "movies": "Películas",
      "series": "Series",
      "liveTV": "TV en Vivo",
      "news": "Noticias",
      "sports": "Deportes",
      "kids": "Niños"
    }
  },
  "liveTV": {
    "title": "TV en Vivo",
    "channels": "Canales",
    "nowPlaying": "Ahora",
    "loadError": "Error al cargar los canales",
    "categories": {
      "all": "Todo",
      "news": "Noticias",
      "sports": "Deportes",
      "entertainment": "Entretenimiento",
      "kids": "Niños",
      "documentary": "Documental"
    }
  },
  "listen": {
    "title": "Escuchar",
    "subtitle": "Radio, Podcasts y Audiolibros",
    "tab": {
      "radio": "Radio",
      "podcasts": "Podcasts",
      "audiobooks": "Audiolibros"
    }
  },
  "radio": {
    "title": "Radio",
    "categories": {
      "all": "Todos",
      "music": "Música",
      "news": "Noticias",
      "talk": "Conversación",
      "jewish": "Judío"
    },
    "noStations": "Sin estaciones de radio disponibles",
    "tryLater": "Intenta de nuevo más tarde",
    "playing": "REPRODUCIENDO",
    "fmSuffix": "FM"
  },
  "podcasts": {
    "title": "Podcasts",
    "episodes": "episodios",
    "categories": {
      "all": "Todos",
      "general": "General",
      "news": "Noticias",
      "politics": "Política",
      "tech": "Tecnología",
      "business": "Negocios",
      "jewish": "Judaísmo",
      "entertainment": "Entretenimiento",
      "sports": "Deportes",
      "history": "Historia",
      "educational": "Educativo"
    },
    "noPodcasts": "Sin podcasts disponibles",
    "tryLater": "Intenta de nuevo más tarde",
    "playLatest": "Reproducir ultimo"
  },
  "vod": {
    "title": "Películas y Series",
    "movies": "Películas",
    "series": "Series",
    "searchPlaceholder": "Buscar películas y series...",
    "noMovies": "No se encontraron películas",
    "noSeries": "No se encontraron series",
    "loadError": "Error al cargar el contenido",
    "showOnlyWithSubtitles": "Mostrar solo con subtítulos",
    "categories": {
      "all": "Todo",
      "drama": "Drama",
      "comedy": "Comedia",
      "action": "Acción",
      "documentary": "Documental",
      "kids": "Niños"
    },
    "allCategories": "Todos",
    "emptyTitle": "Sin contenido disponible",
    "emptyDescription": "Intenta seleccionar otra categoría",
    "allContent": "Todo el contenido",
    "noContent": "No hay contenido disponible",
    "noContentInCategory": "No se encontró contenido en esta categoría"
  },
  "account": {
    "title": "Mi Cuenta",
    "profile": "Perfil",
    "settings": "Configuración",
    "subscription": "Suscripción",
    "manageSubscription": "Gestionar Suscripción",
    "personalDetails": "Datos Personales",
    "billing": "Facturación y Pago",
    "logout": "Cerrar Sesión",
    "login": "Iniciar Sesión",
    "register": "Registrarse",
    "email": "Correo",
    "password": "Contraseña",
    "name": "Nombre",
    "guest": "Invitado",
    "premium": "Premium",
    "basic": "Básico"
  },
  "flows": {
    "title": "Flujos",
    "subtitle": "Experiencias de contenido personalizadas para cada momento",
    "activeNow": "Activo Ahora",
    "start": "Iniciar",
    "skipToday": "Saltar Hoy",
    "systemFlows": "Flujos Predefinidos",
    "customFlows": "Mis Flujos",
    "system": "Sistema",
    "noCustomFlows": "Aún no hay flujos personalizados",
    "createHint": "Crea tu primer flujo personalizado",
    "createCustom": "Crear Flujo Personalizado",
    "createFlow": "Crear Flujo",
    "editFlow": "Editar Flujo",
    "type": "Tipo",
    "systemFlow": "Flujo del Sistema",
    "customFlow": "Flujo Personalizado",
    "schedule": "Horario",
    "content": "Contenido",
    "items": "elementos",
    "aiGenerated": "Generado por AI",
    "autoPlay": "Auto Reproducir",
    "aiEnabled": "Curación AI",
    "shabbatTrigger": "Noche de Shabat",
    "manual": "Manual",
    "flowName": "Nombre del Flujo",
    "flowNamePlaceholder": "ej., Mi Rutina Matutina",
    "description": "Descripción",
    "descriptionPlaceholder": "¿Para qué es este flujo?",
    "startTime": "Hora de Inicio",
    "endTime": "Hora de Fin",
    "actions": "Acciones",
    "details": "Detalles",
    "createFlowDesc": "Diseña tu experiencia de contenido personalizada",
    "editFlowDesc": "Actualiza la configuración y el contenido de tu flujo",
    "basicInfo": "Información Básica",
    "options": "Opciones",
    "autoPlayDesc": "Reproducir automáticamente el siguiente elemento cuando termine el actual",
    "aiEnabledDesc": "Deja que la IA seleccione contenido según tus preferencias",
    "startFlow": "Iniciar Flujo",
    "deleteFlow": "Eliminar Flujo",
    "custom": "Personalizado",
    "morning": "Mañana",
    "evening": "Noche",
    "shabbat": "Shabat",
    "addContent": "Agregar Contenido",
    "contentPicker": {
      "title": "Agregar Contenido al Flujo",
      "tabs": {
        "live": "TV en Vivo",
        "radio": "Radio",
        "vod": "Bajo Demanda",
        "podcast": "Podcasts"
      },
      "search": "Buscar contenido...",
      "selected": "{{count}} seleccionados",
      "addSelected": "Agregar Seleccionados",
      "noResults": "No se encontró contenido",
      "alreadyAdded": "Ya está en el flujo",
      "loadMore": "Cargar Más"
    },
    "flowItems": {
      "title": "Contenido del Flujo",
      "empty": "Sin contenido aún. Haz clic en Agregar Contenido para comenzar.",
      "count": "{{count}} elementos",
      "remove": "Eliminar",
      "moveUp": "Mover Arriba",
      "moveDown": "Mover Abajo",
      "order": "Orden",
      "confirmRemove": "¿Eliminar este elemento del flujo?",
      "maxReached": "Se alcanzó el límite máximo de elementos",
      "more": "elementos más"
    },
    "days": {
      "sunday": "Domingo",
      "monday": "Lunes",
      "tuesday": "Martes",
      "wednesday": "Miércoles",
      "thursday": "Jueves",
      "friday": "Viernes",
      "saturday": "Sábado",
      "sundayShort": "Dom",
      "mondayShort": "Lun",
      "tuesdayShort": "Mar",
      "wednesdayShort": "Mié",
      "thursdayShort": "Jue",
      "fridayShort": "Vie",
      "saturdayShort": "Sáb",
      "selectAll": "Seleccionar Todo",
      "deselectAll": "Deseleccionar Todo",
      "title": "Días Activos",
      "everyday": "Todos los días",
      "everyDay": "Todos los días",
      "weekdays": "Días de semana",
      "weekends": "Fines de semana",
      "noneSelected": "No hay días seleccionados",
      "selectedCount": "{{count}} días seleccionados"
    },
    "trigger": {
      "type": "Tipo de Activación",
      "time": "Basado en Tiempo",
      "shabbat": "Noche de Shabat",
      "holiday": "Día Festivo",
      "skipShabbat": "Saltar en Shabat",
      "skipShabbatDesc": "No ejecutar este flujo en viernes por la noche o sábado",
      "shabbatOffset": "Minutos antes del encendido de velas",
      "shabbatOffsetDesc": "¿Cuántos minutos antes de Shabat debe iniciar este flujo?",
      "calculatedTime": "Hora calculada",
      "thisWeek": "Esta semana: {{day}} a las {{time}}",
      "comingSoon": "Activadores de días festivos próximamente",
      "locationBased": "Basado en Ubicación"
    },
    "examples": {
      "title": "Flujos de Ejemplo",
      "subtitle": "Toca para usar como plantilla",
      "morningRoutine": {
        "name": "Rutina Matutina",
        "desc": "Comienza tu día con noticias, clima y contenido inspirador"
      },
      "eveningWindDown": {
        "name": "Relajación Nocturna",
        "desc": "Relájate con música tranquila y entretenimiento ligero"
      },
      "shabbatPrep": {
        "name": "Preparación para Shabat",
        "desc": "Crea el ambiente para Shabat con contenido especial"
      },
      "coffeeBreak": {
        "name": "Pausa para Café",
        "desc": "Entretenimiento rápido para un descanso corto"
      },
      "sunsetVibes": {
        "name": "Vibraciones del Atardecer",
        "desc": "Relajación de fin de semana con música y contenido ambiental"
      }
    },
    "aiBrief": "Resumen AI",
    "aiBriefDesc": "Recibe un resumen personalizado generado por AI antes de que comience el flujo",
    "aiBriefEnabled": "Resumen AI Activado",
    "validation": {
      "nameRequired": "Se requiere el nombre del flujo",
      "startTimeRequired": "Se requiere hora de inicio para activación por tiempo",
      "endTimeRequired": "Se requiere hora de fin",
      "timeRange": "La hora de fin debe ser después de la hora de inicio",
      "daysRequired": "Selecciona al menos un día",
      "contentRequired": "Se requiere al menos un elemento de contenido"
    },
    "tv": {
      "useCompanion": "Para personalización completa, usa la app Bayit+ en tu teléfono o visita bayit.plus en tu computadora."
    }
  },
  "profile": {
    "title": "Mi Perfil",
    "profileDetails": "Detalles del Perfil",
    "name": "Nombre",
    "notSet": "No establecido",
    "email": "Correo",
    "editProfile": "Editar Perfil",
    "notificationSettings": "Configuración de Notificaciones",
    "security": "Seguridad",
    "changePassword": "Cambiar Contraseña",
    "updatePassword": "Actualiza tu contraseña",
    "connectedDevices": "Dispositivos Conectados",
    "manageDevices": "Administra los dispositivos conectados a tu cuenta",
    "twoFactorAuth": "Autenticación de Dos Factores",
    "addExtraSecurity": "Agrega una capa extra de seguridad",
    "address": {
      "line1": "Calle Principal 123",
      "line2": "Tel Aviv, Israel 6100000"
    },
    "free": "Gratis",
    "premiumPrice": "$7.99/mes",
    "familyPrice": "$12.99/mes",
    "remaining": "restante",
    "tabs": {
      "personal": "Personal",
      "overview": "Resumen",
      "subscription": "Suscripción",
      "notifications": "Notificaciones",
      "security": "Seguridad",
      "ai": "IA y Voz",
      "voice": "Voz y Accesibilidad"
    },
    "subscription": {
      "currentPlan": "Plan Actual",
      "renewsOn": "Se renueva el",
      "manageSubscription": "Administrar Suscripción",
      "cancelSubscription": "Cancelar Suscripción",
      "noActivePlan": "Sin suscripción activa",
      "selectPlan": "Seleccionar Plan"
    },
    "notifications": "Notificaciones",
    "ai": {
      "title": "IA y Personalización",
      "description": "Configura las funciones impulsadas por IA",
      "assistant": "Asistente de IA",
      "assistantDesc": "Recomendaciones personalizadas y ayuda",
      "chatbot": "Asistente de IA",
      "chatbotEnabled": "Habilitar Asistente de IA",
      "chatbotEnabledDesc": "Obtén ayuda para navegar contenido",
      "saveHistory": "Guardar Historial de Conversación",
      "saveHistoryDesc": "Recordar conversaciones anteriores",
      "recommendations": "Recomendaciones",
      "personalizedRecs": "Recomendaciones Personalizadas",
      "personalizedRecsDesc": "Sugerencias de contenido según historial",
      "privacy": "Privacidad y Datos",
      "privacyDesc": "Tus datos están encriptados y seguros",
      "dataConsent": "Análisis de Uso",
      "dataConsentDesc": "Ayuda a mejorar funciones de IA",
      "privacyNote": "Tus datos están encriptados y seguros"
    },
    "voice": {
      "title": "Control por Voz",
      "description": "Navegación manos libres",
      "enabled": "Comandos de Voz",
      "enabledDesc": "Controla la app con tu voz",
      "tts": "Texto a Voz",
      "ttsDesc": "Respuestas de IA leídas en voz alta",
      "wakeWord": "Detección de Palabra Clave",
      "wakeWordDesc": "Di \"Bayit\" para activar",
      "operationMode": "Modo de Operación",
      "operationModeDesc": "Elige cómo interactuar con Bayit+",
      "voiceSearch": "Búsqueda por Voz",
      "voiceSearchEnabled": "Habilitar búsqueda por voz",
      "voiceSearchEnabledDesc": "Busca contenido usando tu voz",
      "constantListening": "Modo Escucha Siempre",
      "constantListeningDesc": "Escuchar continuamente comandos de voz sin presionar un botón",
      "constantListeningPrivacy": "El audio solo se envía a los servidores cuando se detecta habla",
      "holdButtonMode": "Mantener Botón para Hablar",
      "holdButtonModeDesc": "Presionar y mantener el botón del micrófono en lugar de escucha continua",
      "sensitivity": "Sensibilidad de Detección de Voz",
      "sensitivityDesc": "Ajusta la sensibilidad de la detección de voz",
      "sensitivityLow": "Baja (menos falsas alarmas)",
      "sensitivityMedium": "Media (equilibrada)",
      "sensitivityHigh": "Alta (más sensible)",
      "silenceThreshold": "Detección de Silencio",
      "silenceThresholdDesc": "Tiempo de espera después de hablar antes de procesar",
      "language": "Idioma de voz",
      "accessibility": "Accesibilidad",
      "autoSubtitle": "Habilitar subtítulos automáticamente",
      "autoSubtitleDesc": "Mostrar subtítulos automáticamente al reproducir contenido",
      "highContrast": "Modo de alto contraste",
      "highContrastDesc": "Aumentar contraste para mejor visibilidad",
      "textSize": "Tamaño de texto",
      "textSizeSmall": "Pequeño",
      "textSizeMedium": "Mediano",
      "textSizeLarge": "Grande",
      "voiceOnlyInfo": "Solo Voz",
      "voiceOnlyDetails": "Control completo por voz sin botones en pantalla",
      "hybridInfo": "Híbrido",
      "hybridDetails": "Combina control por voz y táctil",
      "classicInfo": "Clásico",
      "classicDetails": "Interfaz táctil tradicional con voz opcional",
      "textToSpeech": "Texto a Voz",
      "ttsEnabled": "Habilitar respuestas de voz",
      "ttsEnabledDesc": "El asistente hablará las respuestas en voz alta",
      "ttsVolume": "Volumen de TTS",
      "ttsSpeed": "Velocidad de TTS",
      "hybridFeedback": "Retroalimentación Híbrida",
      "voiceFeedback": "Retroalimentación por Voz",
      "voiceFeedbackDesc": "Escucha confirmaciones por voz para las acciones",
      "feedbackExample": "Ejemplo: 'Canal cambiado a 13'"
    },
    "dropdown": {
      "myProfile": "Mi Perfil",
      "subscription": "Suscripción",
      "favorites": "Favoritos",
      "downloads": "Descargas",
      "signOut": "Cerrar Sesión"
    },
    "guest": "Invitado",
    "morningRitual": "Ritual Matutino",
    "watchlist": "Mi Lista",
    "favorites": "Favoritos",
    "downloads": "Descargas",
    "settings": "Configuración",
    "language": "Idioma",
    "admin": "Administración",
    "watchTime": "Tiempo de Visualización",
    "minutes": "minutos",
    "hours": "horas",
    "logout": "Cerrar Sesión",
    "premium": "Premium",
    "basic": "Básico",
    "upgrade": "Actualizar a Premium",
    "memberSince": "Miembro desde",
    "aiAssistant": "Asistente de IA",
    "voiceSettings": "Voz",
    "subscriptionButton": "Suscripción",
    "recentActivity": "Actividad Reciente",
    "justNow": "Ahora mismo",
    "hoursAgo": "Hace {{hours}} horas",
    "yesterday": "Ayer",
    "noRecentActivity": "Sin actividad reciente",
    "accountInfo": "Información de la Cuenta",
    "role": "Rol",
    "accountSecurity": "Seguridad de la Cuenta",
    "securityNote": "Tu cuenta está protegida con autenticación encriptada",
    "lastLogin": "Último acceso",
    "dangerZone": "Zona de Peligro",
    "invalidImageType": "Por favor selecciona un archivo de imagen válido (JPEG, PNG, WebP o GIF)",
    "imageTooLarge": "La imagen es demasiado grande. El tamaño máximo es 5MB.",
    "uploadSuccess": "¡Avatar actualizado exitosamente!",
    "uploadFailed": "Error al subir el avatar. Por favor intenta de nuevo.",
    "complimentaryPremium": "ACCESO PREMIUM GRATUITO",
    "emailVerified": "Correo verificado",
    "emailUnverified": "Correo no verificado",
    "phoneVerified": "Teléfono verificado",
    "phoneUnverified": "Teléfono no verificado",
    "completeVerification": "Completa la verificación para desbloquear todas las funciones",
    "unlockPremium": "Desbloquear Funciones Premium",
    "unlockPremiumDescription": "Actualiza para disfrutar de contenido y funciones exclusivas"
  },
  "voiceMode": {
    "voiceOnly": "Solo Voz",
    "voiceOnlyDesc": "Sin control remoto - navegación completa por voz",
    "hybrid": "Híbrido",
    "hybridDesc": "Voz + Remoto - retroalimentación de voz en acciones",
    "classic": "Clásico",
    "classicDesc": "Sin voz - solo control remoto"
  },
  "settings": {
    "title": "Configuración",
    "language": "Idioma",
    "appLanguage": "Idioma de la Aplicación",
    "selectLanguage": "Seleccionar Idioma",
    "languages": {
      "en": "Inglés",
      "he": "Hebreo",
      "es": "Español",
      "zh": "中文",
      "fr": "Francés",
      "it": "Italiano",
      "hi": "Hindi",
      "ta": "Tamil",
      "bn": "Bengalí",
      "ja": "日本語"
    },
    "chatTranslation": "Traducción del chat",
    "autoTranslate": "Traducir mensajes automáticamente",
    "autoTranslateDescription": "Traduce automáticamente los mensajes del chat a tu idioma preferido",
    "notifications": "Notificaciones",
    "pushNotifications": "Notificaciones Push",
    "playback": "Reproducción",
    "quality": "Calidad",
    "subtitles": "Subtítulos",
    "autoplay": "Reproducción Automática",
    "appearance": "Apariencia",
    "darkMode": "Modo Oscuro",
    "privacy": "Privacidad",
    "privacyPolicy": "Política de Privacidad",
    "termsOfService": "Términos de Servicio",
    "about": "Acerca de",
    "display": "Pantalla",
    "homePageSections": "Secciones de Inicio",
    "configureSections": "Configurar secciones de la página de inicio",
    "visibleSections": "Secciones Visibles",
    "hiddenSections": "Secciones Ocultas",
    "dragToReorder": "Arrastra para reordenar",
    "tapToHide": "Toca para ocultar",
    "tapToShow": "Toca para mostrar",
    "resetToDefault": "Restablecer Predeterminado",
    "resetConfirmMessage": "¿Restablecer todas las secciones a la configuración predeterminada?",
    "sectionHidden": "Sección oculta",
    "sectionShown": "Sección visible",
    "replayTour": "Repetir el tour de características"
  },
  "help": {
    "subtitle": "¿Cómo podemos ayudarte?",
    "email": "Soporte por Correo Electrónico",
    "phone": "Soporte Telefónico",
    "chat": "Chat en Vivo",
    "chatAvailable": "Disponible 24/7",
    "openTooltip": "Abrir tooltip de ayuda",
    "openHelp": "Abrir menú de ayuda",
    "howTo": "Cómo usar",
    "relatedArticles": "Artículos relacionados",
    "stillNeedHelp": "¿Aún necesitas ayuda?",
    "contactSupport": "Contactar Soporte",
    "previous": "Anterior",
    "next": "Siguiente",
    "getStarted": "Comenzar",
    "skipTutorial": "Omitir tutorial",
    "actions": {
      "search": "Buscar",
      "docs": "Documentación",
      "faq": "Preguntas Frecuentes",
      "support": "Soporte",
      "tutorial": "Tutorial"
    },
    "search": {
      "placeholder": "Buscar en ayuda...",
      "noResults": "No se encontraron resultados para \"{{query}}\"",
      "noResultsHint": "Prueba con otras palabras clave o explora las categorías",
      "recent": "Búsquedas recientes",
      "popular": "Búsquedas populares"
    },
    "categories": {
      "getting-started": "Comenzar",
      "features": "Funciones",
      "judaism": "Judaísmo",
      "platform-guides": "Guías de Plataforma",
      "account": "Cuenta",
      "troubleshooting": "Solución de Problemas",
      "parents": "Para Padres",
      "admin": "Administradores",
      "developer": "Desarrolladores"
    },
    "faq": {
      "title": "Preguntas Frecuentes",
      "q1": "¿Cómo cambio mi plan de suscripción?",
      "a1": "Ve a Configuración > Suscripción para ver y cambiar tu plan actual. Puedes actualizar o degradar en cualquier momento.",
      "q2": "¿Cómo descargo contenido para verlo sin conexión?",
      "a2": "Toca el ícono de descarga en cualquier contenido para guardarlo para visualización sin conexión. Las descargas están disponibles solo en dispositivos móviles.",
      "q3": "¿Por qué no se reproduce mi video?",
      "a3": "Verifica tu conexión a internet. Si el problema persiste, intenta limpiar la caché de la aplicación o reiniciar la aplicación.",
      "q4": "¿Cómo cancelo mi suscripción?",
      "a4": "Puedes cancelar tu suscripción en cualquier momento a través de Configuración > Suscripción > Cancelar Plan. Continuarás teniendo acceso hasta el final de tu período de facturación."
    },
    "onboarding": {
      "welcome": {
        "title": "Bienvenido a Bayit+",
        "description": "Tu plataforma integral de entretenimiento judío y streaming familiar."
      },
      "liveTv": {
        "title": "Ver TV en Vivo",
        "description": "Sintoniza cientos de canales en vivo con guía de programación electrónica interactiva."
      },
      "vod": {
        "title": "Contenido Bajo Demanda",
        "description": "Explora miles de películas, series y programas a tu propio ritmo."
      },
      "voice": {
        "title": "Control por Voz",
        "description": "Di \"Hey Jarvis\" o toca el botón del micrófono para control manos libres."
      },
      "profiles": {
        "title": "Perfiles Familiares",
        "description": "Crea perfiles personalizados para cada miembro de la familia con controles parentales."
      }
    }
  },
  "voice": {
    "panelTitle": "Asistente de voz",
    "typeCommand": "Escribe un comando...",
    "controlExecuted": "Ejecutado: {{action}}",
    "timerSet": "Temporizador configurado para {{amount}} {{unit}}",
    "chatPending": "Procesando tu mensaje...",
    "suggestion": {
      "watchLive": "Ver TV en vivo",
      "search": "Buscar contenido",
      "listenRadio": "Escuchar la radio"
    },
    "error": {
      "micDenied": "Acceso al micrófono denegado",
      "notSupported": "Los comandos de voz no son compatibles con este navegador",
      "recognitionFailed": "No se pudo entender. Por favor, inténtalo de nuevo."
    }
  },
  "errors": {
    "networkError": "Error de Red",
    "loadingFailed": "Carga Fallida",
    "tryAgain": "Intentar de Nuevo",
    "offline": {
      "title": "Sin Conexión a Internet",
      "message": "Estás sin conexión actualmente. Algunas funciones pueden no estar disponibles.",
      "ttsMessage": "Sin conexión a internet. Ahora estás en modo sin conexión."
    },
    "online": {
      "title": "Conexión Restaurada",
      "message": "Estás de nuevo en línea.",
      "ttsMessage": "Conexión a internet restaurada."
    },
    "api": {
      "badRequest": "Algo salió mal. Por favor, inténtalo de nuevo.",
      "unauthorized": "Por favor, inicia sesión para continuar.",
      "forbidden": "No tienes permiso para acceder a este contenido.",
      "notFound": "El contenido que buscas no está disponible.",
      "rateLimit": "Estás haciendo demasiadas solicitudes. Por favor, espera un momento.",
      "serverError": "Nuestros servidores tienen problemas. Por favor, inténtalo más tarde.",
      "unknown": "Algo salió mal. Por favor, inténtalo de nuevo.",
      "networkTimeout": "No se puede conectar a nuestros servidores. Por favor, verifica tu conexión.",
      "offlineMessage": "Estás sin conexión. Por favor, verifica tu conexión a internet.",
      "requestFailed": "Algo salió mal. Por favor, inténtalo de nuevo."
    },
    "voice": {
      "permissionDenied": "Se requiere acceso al micrófono para comandos de voz. Por favor, habilítalo en Configuración.",
      "recognitionFailed": "No entendí eso. Por favor, inténtalo de nuevo.",
      "commandFailed": "Comando de voz falló. Por favor, inténtalo de nuevo."
    },
    "widget": {
      "loadFailed": "No se puede cargar el widget. Por favor, inténtalo de nuevo."
    },
    "buttons": {
      "ok": "OK",
      "retry": "Reintentar",
      "cancel": "Cancelar"
    },
    "title": "Error",
    "networkUnavailable": "Red no disponible",
    "no_audio_url": "URL de audio no disponible",
    "connection_failed": "Conexión Fallida",
    "quota_exceeded": "Cuota Excedida",
    "server_error": "Error del Servidor"
  },
  "player": {
    "loading": "Cargando...",
    "retry": "Reintentar",
    "error": "Error al reproducir el video",
    "back": "← Volver",
    "liveBadge": "EN VIVO",
    "noStream": "Transmisión no disponible",
    "loadError": "Error al cargar la transmisión",
    "settings": "Configuración",
    "subtitles": "Subtitulos",
    "playbackSpeed": "Velocidad de Reproducción",
    "quality": "Calidad",
    "auto": "Automático",
    "previousChapter": "Capítulo anterior",
    "nextChapter": "Siguiente capítulo",
    "skipBackward": "Retroceder 30 segundos",
    "skipForward": "Avanzar 30 segundos",
    "restart": "Reiniciar desde el principio",
    "subtitlesOff": "Desactivados",
    "speed": "Velocidad",
    "subscription": {
      "requiredTitle": "Suscripción Requerida",
      "requiredMessage": "requiere una suscripción paga",
      "upgradeInfo": "Mejora tu suscripción para acceder al contenido premium",
      "upgrade": "Actualizar Ahora"
    },
    "ai": {
      "dub": "Doblar",
      "dubbing": "Doblaje",
      "featuresTitle": "Funciones de IA",
      "languagePrimary": "Primario",
      "languageSecondary": "Secundario (Opcional)",
      "languageTitle": "Idioma de IA",
      "liveTranslate": "Traduccion en vivo",
      "selectLanguage": "Seleccionar idioma",
      "split": "Dividir",
      "togglePanel": "Mostrar/ocultar panel de IA",
      "translate": "Traducir",
      "trivia": "Trivia",
      "triviaToggle": "Trivia"
    },
    "catchup": {
      "description": "Te perdiste el inicio? Obtene un resumen impulsado por IA de lo que paso hasta ahora.",
      "generateSummary": "Generar resumen",
      "summaryTitle": "Resumen",
      "title": "Ponerse al dia",
      "keyPoints": "Puntos clave",
      "transcript": "Transcripcion"
    },
    "chat": {
      "title": "Chat en vivo",
      "messagePlaceholder": "Escribe un mensaje..."
    },
    "companion": {
      "noContext": "No hay contexto cultural disponible para este contenido todavia.",
      "quizComplete": "Cuestionario completado",
      "quizRetry": "Reintentar",
      "quizStart": "Iniciar cuestionario",
      "quizTitle": "Listo para probar tus conocimientos?",
      "quizTryAgain": "Intentar de nuevo",
      "tabContext": "Contexto",
      "tabQuiz": "Cuestionario",
      "tabVocabulary": "Vocabulario",
      "tapWords": "Toca las palabras en los subtitulos para agregarlas aqui",
      "title": "Compan~ero IA",
      "loadError": "Error al cargar los datos de aprendizaje"
    },
    "controls": {
      "audioTrack": "Pista de audio",
      "continueWatching": "Seguir viendo",
      "dismiss": "Cerrar",
      "goBack": "Volver",
      "navigateBack": "Navegar atras",
      "on": "Activado",
      "pause": "Pausar",
      "play": "Reproducir",
      "preview": "Vista previa",
      "selected": "Seleccionado",
      "send": "Enviar",
      "skip": "Omitir",
      "close": "Cerrar",
      "exitFullscreen": "Salir de pantalla completa",
      "fullscreen": "Pantalla completa",
      "restart": "Reiniciar",
      "skipBackward": "Retroceder",
      "skipForward": "Avanzar",
      "volume": "Volumen"
    },
    "dubbing": {
      "notNow": "Ahora no",
      "premiumMessage": "El doblaje en vivo requiere una suscripcion Premium o Beta 500",
      "premiumTitle": "Funcion Premium",
      "upgrade": "Mejorar",
      "voiceTitle": "Voz de doblaje",
      "settings_title": "Configuración de Doblaje en Vivo",
      "target_language": "Idioma de Destino"
    },
    "errors": {
      "streamLimitMessage": "Has alcanzado el maximo de {{maxStreams}} transmisiones simultaneas. Por favor detiene otra transmision o mejora tu plan.",
      "streamLimitTitle": "Limite de transmisiones",
      "upgradePlan": "Mejorar plan"
    },
    "audio_description": "Descripción de Audio",
    "dismiss": "Descartar",
    "scene_search": "Búsqueda de Escena",
    "search_placeholder": "Buscar una escena...",
    "language_ratio": "Proporción de Aprendizaje de Idioma",
    "go_back": "Volver",
    "sleepTimer": {
      "title": "Temporizador de apagado",
      "subtitle": "Pausar la reproduccion automaticamente despues de un tiempo establecido",
      "minutes": "{{count}} min",
      "customPlaceholder": "Minutos personalizados",
      "set": "Establecer temporizador",
      "remaining": "Apagado en {{time}}",
      "extend": "+15 min",
      "cancel": "Cancelar temporizador",
      "off": "Apagado",
      "setTimer": "Configurar temporizador"
    },
    "openSubs": {
      "title": "Buscar subtitulos",
      "searchPlaceholder": "Buscar por titulo...",
      "search": "Buscar",
      "searchFailed": "Busqueda fallida. Intentalo de nuevo.",
      "downloads": "{{count}} descargas",
      "noResults": "No se encontraron subtitulos"
    },
    "dialogue": {
      "cancel": "Cancelar",
      "close": "Cerrar",
      "placeholder": "Escribe tu mensaje...",
      "selectCharacter": "Seleccionar personaje",
      "send": "Enviar",
      "sharedSession": "Sesion compartida",
      "waitingForTurn": "Esperando tu turno...",
      "yourAvatar": "Tu avatar"
    },
    "interaction": {
      "next": "Siguiente",
      "previous": "Anterior",
      "skip": "Omitir",
      "start": "Iniciar interacción",
      "window": "Ventana de interacción: {{duration}} segundos"
    },
    "pauseAsk": {
      "askAgain": "Preguntar de nuevo",
      "placeholder": "Pregunta sobre esta escena...",
      "resume": "Reanudar",
      "resumeMovie": "Reanudar pelicula",
      "selectCharacter": "Seleccionar personaje",
      "title": "Pausar y preguntar"
    },
    "phraseBreakdown": {
      "literal": "Literal",
      "meaning": "Significado",
      "origin": "Origen",
      "funFact": "Dato curioso",
      "usage": "Uso: {{level}}"
    },
    "translation": {
      "example": "Ejemplo:",
      "arrow": "→"
    },
    "subtitleMode": {
      "title": "Modo de subtítulos",
      "modes": {
        "regular": {
          "name": "Regular",
          "description": "Subtítulos hebreos estándar sin marcas vocálicas"
        },
        "nikud": {
          "name": "Nikud",
          "description": "Hebreo con marcas vocálicas para facilitar la lectura"
        },
        "shoresh": {
          "name": "Shoresh",
          "description": "Aprendizaje basado en raíces con orígenes de palabras resaltados"
        },
        "engrew": {
          "name": "Engrew",
          "description": "Transliteración al inglés con contexto hebreo"
        },
        "heblish": {
          "name": "Heblish",
          "description": "Inglés con términos hebreos y contexto cultural"
        },
        "grammarFlip": {
          "name": "Inversión gramatical",
          "description": "Estructura de oraciones hebreas con palabras en inglés"
        },
        "slangSynthesis": {
          "name": "Síntesis de argot",
          "description": "Jerga cultural y modismos explicados"
        }
      }
    }
  },
  "empty": {
    "noContent": "No hay contenido disponible",
    "tryAnotherCategory": "Intenta seleccionar otra categoría",
    "noPodcasts": "No hay podcasts disponibles",
    "tryLater": "Intenta de nuevo más tarde",
    "noResults": "No se encontraron resultados"
  },
  "content": {
    "play": "Reproducir",
    "addToList": "Agregar a Lista",
    "inList": "En Lista",
    "details": "Detalles",
    "synopsis": "Sinopsis",
    "genre": "Género",
    "genres": "Géneros",
    "runtime": "Duración",
    "released": "Lanzamiento",
    "director": "Director",
    "starring": "Protagonistas",
    "cast": "Reparto",
    "season": "Temporada",
    "seasons": "Temporadas",
    "episode": "Episodio",
    "episodes": "Episodios",
    "ep": "Ep",
    "selectSeason": "Seleccionar Temporada",
    "noEpisodes": "No hay episodios disponibles",
    "noEpisodesAvailable": "No hay episodios disponibles para reproducir",
    "loadingSeries": "Cargando información de la serie...",
    "votes": "votos",
    "rating": "Calificación",
    "imdbRating": "Calificación IMDB",
    "preview": "Vista previa",
    "previewPlaying": "Vista previa reproduciéndose",
    "trailerPlaying": "Tráiler reproduciéndose",
    "watchTrailer": "Ver Tráiler",
    "youMayAlsoLike": "También te puede gustar",
    "relatedContent": "Contenido Relacionado",
    "notFound": "Contenido no encontrado",
    "availableSubtitles": "Subtítulos Disponibles",
    "subtitleSelected": "Seleccionado: {{language}}"
  },
  "breadcrumbs": {
    "series": "Serie",
    "movie": "Película",
    "watching": "Viendo",
    "channel": "Canal",
    "station": "Estación",
    "podcast": "Podcast",
    "watchlist": "Mi Lista",
    "downloads": "Descargas"
  },
  "favorites": {
    "title": "Favoritos",
    "items": "elementos",
    "empty": "Sin favoritos aún",
    "emptyHint": "Añade elementos a tus favoritos"
  },
  "downloads": {
    "title": "Descargas",
    "items": "elementos",
    "storage": "Almacenamiento",
    "empty": "Sin descargas",
    "emptyHint": "Descarga contenido para ver sin conexion",
    "paused": "Pausado"
  },
  "watchlist": {
    "filters": {
      "all": "Todos",
      "continue": "Continuar viendo",
      "movies": "Películas",
      "series": "Series",
      "kids": "Niños",
      "judaism": "Judaísmo",
      "podcasts": "Podcasts",
      "radio": "Radio"
    },
    "title": "Mi lista",
    "items": "elementos",
    "watched": "visto",
    "empty": "Tu lista está vacía",
    "emptyHint": "Comienza a ver y los elementos aparecerán aquí"
  },
  "widgets": {
    "empty": "Sin widgets",
    "emptyHint": "Tus widgets aparecerán aquí",
    "emptyPersonal": "Sin widgets personales todavía",
    "emptyPersonalHint": "Crea tu primer widget personal o añade widgets del sistema arriba",
    "itemsTotal": "widgets totales",
    "systemWidgets": "Widgets del Sistema",
    "systemWidgetsHint": "Explora y añade widgets a tu colección",
    "myWidgets": "Mis Widgets Personales",
    "myWidgetsHint": "Widgets que has creado",
    "personalWidgets": "Mis Widgets",
    "noSystemWidgets": "No hay widgets del sistema disponibles",
    "added": "Añadido",
    "add": "Añadir",
    "remove": "Eliminar",
    "show": "Mostrar",
    "hidden": "Oculto",
    "addToCollection": "Añadir a Mis Widgets",
    "removeFromCollection": "Eliminar de Mis Widgets",
    "contentTypes": {
      "liveChannel": "Canal en Vivo",
      "iframe": "Contenido Web",
      "podcast": "Podcast",
      "radio": "Radio",
      "vod": "Vídeo",
      "custom": "Personalizado",
      "widget": "Widget"
    },
    "form": {
      "title": "Crear Widget",
      "basicInfo": "Información Básica",
      "titlePlaceholder": "Título del Widget",
      "titleRequired": "El título del widget es requerido",
      "descriptionPlaceholder": "Descripción (opcional)",
      "iconPlaceholder": "Emoji icono (ej. 📺)",
      "content": "Contenido",
      "fromLibrary": "De la Biblioteca",
      "iframe": "iFrame",
      "selectContent": "Seleccionar Contenido (Canales, Podcasts, Programas, etc.)",
      "iframeUrl": "URL del iFrame",
      "iframeUrlRequired": "La URL del iFrame es requerida",
      "iframeTitle": "Título del iFrame",
      "positionSize": "Posición y Tamaño",
      "behavior": "Comportamiento",
      "mutedByDefault": "Silenciado por Defecto",
      "closable": "Puede Cerrarse",
      "draggable": "Puede Arrastrarse",
      "widgetOrder": "Orden del Widget",
      "orderPlaceholder": "Orden (0 = primero)",
      "saveWidget": "Guardar Widget",
      "saving": "Guardando...",
      "cancel": "Cancelar",
      "change": "Cambiar"
    }
  },
  "trending": {
    "title": "Tendencias en Israel",
    "noTopics": "No hay temas de tendencia disponibles",
    "topStory": "HISTORIA PRINCIPAL",
    "sources": "Fuentes",
    "categories": {
      "security": "Seguridad",
      "politics": "Politica",
      "tech": "Tecnologia",
      "culture": "Cultura",
      "sports": "Deportes",
      "economy": "Economia",
      "entertainment": "Entretenimiento",
      "weather": "Clima",
      "health": "Salud",
      "general": "General"
    }
  },
  "cultures": {
    "title": "Selecciona tu Cultura",
    "select": "Seleccionar Cultura",
    "selectCulture": "Elige tu Comunidad",
    "selectCultureDescription": "Selecciona tu comunidad cultural para personalizar tu experiencia",
    "changeCulture": "Cambiar Cultura",
    "israeli": {
      "name": "Israelí",
      "description": "Contenido para la comunidad israeli"
    },
    "chinese": {
      "name": "Chino",
      "description": "Contenido para la comunidad china"
    },
    "japanese": {
      "name": "Japones",
      "description": "Contenido para la comunidad japonesa"
    },
    "korean": {
      "name": "Coreano",
      "description": "Contenido para la comunidad coreana"
    },
    "indian": {
      "name": "Indio",
      "description": "Contenido para la comunidad india"
    }
  },
  "cultureTrending": {
    "whatsHotIn": "Tendencias en {{location}}",
    "noTopics": "No hay temas de tendencia disponibles",
    "sources": "Fuentes",
    "categories": {
      "security": "Seguridad",
      "politics": "Politica",
      "tech": "Tecnologia",
      "technology": "Tecnologia",
      "culture": "Cultura",
      "sports": "Deportes",
      "economy": "Economia",
      "finance": "Finanzas",
      "entertainment": "Entretenimiento",
      "weather": "Clima",
      "health": "Salud",
      "food": "Comida",
      "fashion": "Moda",
      "travel": "Viajes",
      "history": "Historia",
      "expat": "Vida de Expatriados",
      "general": "General"
    }
  },
  "cultureClock": {
    "timeIn": "Hora en {{location}}",
    "shabbat": "Shabat",
    "weekend": "Fin de Semana"
  },
  "cultureCities": {
    "connectionTo": "Conexion con {{city}}",
    "explore": "Explorar {{city}}",
    "noContent": "No hay contenido disponible para esta ciudad",
    "categories": {
      "all": "Todo",
      "history": "Historia",
      "culture": "Cultura",
      "finance": "Finanzas",
      "tech": "Tecnologia",
      "food": "Comida",
      "expat": "Vida de Expatriados",
      "news": "Noticias",
      "entertainment": "Entretenimiento"
    }
  },
  "clock": {
    "israel": "Israel",
    "local": "Local",
    "shabbatShalom": "Shabat Shalom!",
    "erevShabbat": "Erev Shabat",
    "candleLighting": "Encendido de Velas",
    "parasha": "Parashá"
  },
  "ritual": {
    "title": "Ritual Matutino",
    "greeting": "¡Buenos Días!",
    "israelUpdate": "Es la tarde en Israel, las noticias informan sobre desarrollos en curso",
    "recommendation": "Te recomendamos empezar con las noticias de la mañana y luego pasar a la radio",
    "preparingRitual": "Preparando tu ritual matutino...",
    "israelTime": "Hora en Israel",
    "day": "Día",
    "letsStart": "Empecemos",
    "skipToday": "Saltar por Hoy",
    "finish": "Terminar",
    "noContentNow": "No hay contenido disponible ahora",
    "typeLive": "En Vivo",
    "typeRadio": "Radio",
    "typeVideo": "Vídeo"
  },
  "watchParty": {
    "title": "Fiesta de visualización",
    "create": "Crear fiesta",
    "join": "Unirse a la fiesta",
    "active": "Fiesta activa",
    "createTitle": "Crear Watch Party",
    "joinTitle": "Unirse a la fiesta",
    "enterCode": "Ingresa el código de la sala",
    "roomCode": "Código de la sala",
    "copyCode": "Copiar código",
    "codeCopied": "¡Código copiado!",
    "participants": "Participantes",
    "host": "Anfitrión",
    "you": "Tú",
    "leave": "Salir de la fiesta",
    "end": "Terminar fiesta",
    "chat": "Chat",
    "sendMessage": "Enviar mensaje",
    "typeMessage": "Escribe un mensaje...",
    "synced": "Sincronizado",
    "syncing": "Sincronizando...",
    "hostPaused": "El anfitrión pausó",
    "userJoined": "{{name}} se unió",
    "userLeft": "{{name}} salió",
    "partyEnded": "La fiesta ha terminado",
    "connecting": "Conectando...",
    "options": {
      "chatEnabled": "Habilitar chat",
      "syncPlayback": "Sincronizar reproducción"
    },
    "errors": {
      "invalidCode": "Código inválido",
      "partyFull": "La fiesta está llena",
      "partyEnded": "La fiesta ha terminado",
      "connectionError": "Error de conexión",
      "createFailed": "Error al crear la fiesta",
      "joinFailed": "Error al unirse"
    },
    "audio": {
      "mute": "Silenciar",
      "unmute": "Activar sonido",
      "speaking": "Hablando",
      "connecting": "Conectando audio...",
      "noAudio": "Audio no disponible"
    },
    "textOnlyMode": "Solo chat de texto",
    "endParty": "Terminar fiesta"
  },
  "footer": {
    "brandDescription": "Tu hogar en EE.UU. Transmisiones de TV, VOD, radio y podcasts en hebreo.",
    "browse": "Explorar",
    "account": "Cuenta",
    "support": "Soporte",
    "legal": "Legal",
    "location": "EE.UU.",
    "links": {
      "home": "Inicio",
      "liveTV": "TV en Vivo",
      "vod": "Películas y Series",
      "radio": "Radio",
      "podcasts": "Podcasts",
      "judaism": "Judaísmo",
      "profile": "Mi Perfil",
      "favorites": "Favoritos",
      "watchlist": "Mi Lista",
      "subscribe": "Suscripción",
      "downloads": "Descargas",
      "help": "Centro de Ayuda",
      "faq": "Preguntas Frecuentes",
      "contact": "Contáctenos",
      "feedback": "Enviar Comentarios",
      "terms": "Términos de Servicio",
      "privacy": "Política de Privacidad",
      "cookies": "Política de Cookies",
      "licenses": "Licencias"
    },
    "newsletter": {
      "title": "Mantente Conectado",
      "description": "Recibe actualizaciones sobre nuevos contenidos y funciones",
      "placeholder": "Tu correo electrónico",
      "success": "¡Gracias por suscribirte!"
    },
    "apps": {
      "title": "Descarga Nuestra App",
      "downloadOn": "Descargar en",
      "getItOn": "Disponible en",
      "appStore": "App Store",
      "googlePlay": "Google Play"
    },
    "social": {
      "facebook": "Facebook",
      "twitter": "Twitter",
      "instagram": "Instagram",
      "youtube": "YouTube"
    },
    "copyright": "© {{year}} Bayit+. Todos los derechos reservados.",
    "poweredBy": "Desarrollado por",
    "sitemap": "Mapa del Sitio",
    "accessibility": "Accesibilidad",
    "navigation": "Navegación",
    "liveTV": "TV en Vivo",
    "moviesAndSeries": "Películas y Series",
    "radioStations": "Estaciones de Radio",
    "myProfile": "Mi Perfil",
    "subscriptions": "Suscripciones",
    "helpAndSupport": "Ayuda y Soporte",
    "termsOfUse": "Términos de Uso",
    "privacyPolicy": "Política de Privacidad",
    "contactUs": "Contáctenos"
  },
  "chapters": {
    "title": "Capítulos",
    "noChapters": "No hay capítulos disponibles",
    "generating": "Generando capítulos...",
    "jumpTo": "Ir a",
    "current": "Ahora",
    "categories": {
      "intro": "Introducción",
      "news": "Noticias",
      "security": "Seguridad",
      "politics": "Política",
      "economy": "Economía",
      "sports": "Deportes",
      "weather": "Clima",
      "culture": "Cultura",
      "conclusion": "Conclusión"
    },
    "chapterLabel": "Capitulo {{number}}",
    "chapter_number": "Capítulo {{number}}"
  },
  "admin": {
    "brand": {
      "title": "Admin Bayit+",
      "subtitle": "Gestión del Sistema"
    },
    "backToApp": "Volver a la App",
    "refunds": {
      "subtitle": "Gestionar solicitudes de reembolso",
      "approveModal": {
        "title": "Confirmar Aprobación",
        "message": "¿Aprobar reembolso de {{amount}}?"
      },
      "confirmApprove": "¿Aprobar reembolso de {{amount}}?",
      "confirmDelete": "¿Eliminar solicitud de reembolso?",
      "rejectModal": {
        "title": "Rechazar Solicitud de Reembolso",
        "message": "Rechazando reembolso de {{amount}}",
        "reasonLabel": "Motivo del Rechazo",
        "reasonPlaceholder": "Por favor ingresa el motivo del rechazo...",
        "submitButton": "Rechazar Solicitud"
      },
      "status": {
        "pending": "Pendiente",
        "approved": "Aprobado",
        "rejected": "Rechazado"
      },
      "columns": {
        "id": "ID",
        "user": "Usuario",
        "amount": "Monto",
        "reason": "Motivo",
        "status": "Estado",
        "requestDate": "Fecha de Solicitud"
      },
      "stats": {
        "pendingTitle": "Pendiente de Aprobación",
        "approvedTitle": "Aprobados",
        "rejectedTitle": "Rechazados",
        "totalRefunded": "Total Reembolsado"
      },
      "emptyMessage": "No se encontraron solicitudes de reembolso",
      "errors": {
        "rejectReasonRequired": "Por favor ingresa un motivo de rechazo"
      },
      "title": "Reembolsos"
    },
    "plans": {
      "title": "Gestión de Planes",
      "subtitle": "Configurar y gestionar planes de suscripción",
      "createButton": "Nuevo Plan",
      "inactive": "Inactivo",
      "subscribersLabel": "Suscriptores:",
      "intervals": {
        "monthly": "mes",
        "yearly": "año"
      },
      "trialDays": "Prueba gratis de {{days}} días",
      "modal": {
        "editTitle": "Editar Plan",
        "createTitle": "Nuevo Plan"
      },
      "form": {
        "nameEn": "Nombre (Inglés)",
        "nameHe": "Nombre (Hebreo)",
        "price": "Precio ($)",
        "interval": "Período",
        "trialDays": "Días de Prueba",
        "features": "Características (una por línea)",
        "active": "Plan Activo"
      },
      "errors": {
        "requiredFields": "El nombre y el precio son obligatorios"
      },
      "confirmDelete": "¿Eliminar el plan \"{{name}}\"?"
    },
    "emailCampaigns": {
      "subtitle": "Crear y gestionar campañas de correo",
      "createButton": "Nueva Campaña",
      "searchPlaceholder": "Buscar campaña...",
      "emptyMessage": "No se encontraron campañas",
      "status": {
        "draft": "Borrador",
        "active": "Activo",
        "scheduled": "Programado",
        "completed": "Completado"
      },
      "columns": {
        "name": "Nombre de Campaña",
        "status": "Estado",
        "sent": "Enviados",
        "opened": "Abiertos",
        "clicked": "Clickeados",
        "created": "Creado",
        "actions": "Acciones"
      },
      "editModal": {
        "title": "Editar Campaña"
      },
      "sendTestEmail": "Enviar Prueba",
      "confirmSend": "¿Enviar la campaña \"{{name}}\"?",
      "confirmDelete": "¿Eliminar la campaña \"{{name}}\"?",
      "testEmailSent": "¡Correo de prueba enviado!",
      "createModal": {
        "title": "Nueva Campaña de Correo"
      },
      "form": {
        "name": "Nombre de Campaña",
        "namePlaceholder": "Por ej., Oferta de Fin de Año",
        "subject": "Asunto del Correo",
        "subjectPlaceholder": "Asunto que verán los destinatarios",
        "body": "Contenido",
        "bodyPlaceholder": "Contenido del correo...",
        "submitButton": "Crear Campaña",
        "requiredFields": "Se requieren nombre y asunto"
      },
      "testModal": {
        "title": "Enviar Correo de Prueba",
        "emailLabel": "Dirección de Correo",
        "emailPlaceholder": "test@example.com",
        "submitButton": "Enviar Prueba"
      },
      "errors": {
        "requiredFields": "El nombre y el asunto son obligatorios"
      }
    },
    "dashboard": {
      "subtitle": "Descripción General del Sistema",
      "refresh": "Actualizar",
      "timeAgo": {
        "minutes": "hace {{count}} minutos",
        "hours": "hace {{count}} horas"
      },
      "title": "Panel de Control",
      "users": "Usuarios",
      "revenue": "Ingresos",
      "subscriptions": "Suscripciones",
      "recentActivity": "Actividad Reciente",
      "quickActions": "Acciones Rápidas"
    },
    "common": {
      "all": "Todos",
      "cancel": "Cancelar",
      "save": "Guardar",
      "active": "Activo",
      "back": "Volver",
      "filterAction": "Acción",
      "filterResource": "Recurso",
      "filterUser": "Usuario",
      "filterDateRange": "Rango de fechas"
    },
    "stats": {
      "totalUsers": "Total de Usuarios",
      "activeUsers": "Usuarios Activos",
      "newToday": "Nuevos Hoy",
      "newThisWeek": "Nuevos Esta Semana",
      "totalRevenue": "Ingresos Totales",
      "revenueToday": "Ingresos Hoy",
      "revenueMonth": "Ingresos Este Mes",
      "arpu": "Ingreso promedio por usuario",
      "activeSubscriptions": "Suscripciones Activas",
      "churnRate": "Tasa de Pérdida"
    },
    "actions": {
      "new": "Nuevo",
      "addUser": "Agregar Usuario",
      "newCampaign": "Nueva Campaña",
      "sendEmail": "Enviar Correo",
      "viewReports": "Ver Reportes"
    },
    "auditActions": {
      "user_created": "Usuario Creado",
      "user_updated": "Usuario Actualizado",
      "user_deleted": "Usuario eliminado",
      "user_role_changed": "Rol de Usuario Cambiado",
      "campaign_created": "Campaña Creada",
      "campaign_updated": "Campaña Actualizada",
      "campaign_deleted": "Campaña Eliminada",
      "campaign_activated": "Campaña Activada",
      "subscription_created": "Suscripción Creada",
      "subscription_updated": "Suscripción Actualizada",
      "subscription_canceled": "Suscripción Cancelada",
      "subscription_deleted": "Suscripción eliminada",
      "refund_processed": "Reembolso Procesado",
      "payment_received": "Pago Recibido",
      "settings_updated": "Configuración Actualizada",
      "login": "Iniciar sesión",
      "logout": "Cerrar sesión",
      "content_created": "Contenido Creado",
      "content_updated": "Contenido Actualizado",
      "content_deleted": "Contenido Eliminado",
      "content_published": "Contenido Publicado",
      "content_unpublished": "Contenido Despublicado",
      "category_created": "Categoría Creada",
      "category_updated": "Categoría Actualizada",
      "category_deleted": "Categoría Eliminada",
      "live_channel_created": "Canal en Vivo Creado",
      "live_channel_updated": "Canal en Vivo Actualizado",
      "live_channel_deleted": "Canal en Vivo Eliminado",
      "radio_station_created": "Estación de Radio Creada",
      "radio_station_updated": "Estación de Radio Actualizada",
      "radio_station_deleted": "Estación de Radio Eliminada",
      "podcast_created": "Podcast Creado",
      "podcast_updated": "Podcast Actualizado",
      "podcast_deleted": "Podcast Eliminado",
      "podcast_episode_created": "Episodio de Podcast Creado",
      "podcast_episode_updated": "Episodio de Podcast Actualizado",
      "podcast_episode_deleted": "Episodio de Podcast Eliminado",
      "content_imported": "Contenido Importado",
      "widget_created": "Widget Creado",
      "widget_updated": "Widget Actualizado",
      "widget_deleted": "Widget Eliminado",
      "widget_published": "Widget Publicado",
      "widget_unpublished": "Widget No Publicado"
    },
    "placeholder": {
      "userId": "Ingresa ID de usuario",
      "discount": "0"
    },
    "titles": {
      "users": "Usuarios",
      "transactions": "Transacciones",
      "subscriptions": "Suscripciones",
      "refunds": "Reembolsos",
      "plans": "Planes",
      "campaigns": "Campañas",
      "auditLogs": "Registros de Auditoría",
      "pushNotifications": "Notificaciones Push",
      "billing": "Facturación",
      "marketing": "Marketing",
      "content": "Biblioteca de Contenido",
      "categories": "Categorías",
      "liveChannels": "Canales en Vivo",
      "radioStations": "Estaciones de Radio",
      "podcasts": "Pódcasts",
      "settings": "Configuración"
    },
    "nav": {
      "dashboard": "Panel de Control",
      "users": "Usuarios",
      "campaigns": "Campañas",
      "billing": "Facturación",
      "billingOverview": "Resumen",
      "transactions": "Transacciones",
      "refunds": "Reembolsos",
      "subscriptions": "Suscripciones",
      "subscriptionsList": "Suscriptores",
      "plans": "Planes",
      "marketing": "Marketing",
      "marketingDashboard": "Resumen",
      "emailCampaigns": "Campañas de Correo",
      "pushNotifications": "Notificaciones Push",
      "content": "Contenido",
      "contentLibrary": "Biblioteca de Contenido",
      "categories": "Categorías",
      "liveChannels": "Canales en Vivo",
      "radioStations": "Estaciones de Radio",
      "podcasts": "Pódcasts",
      "widgets": "Widgets",
      "recordings": "Grabaciones",
      "uploads": "Cargas",
      "settings": "Configuración",
      "auditLogs": "Registro de Auditoría",
      "librarian": "Agente Bibliotecario",
      "featured": "Destacado"
    },
    "featured": {
      "title": "Contenido Destacado",
      "subtitle": "Administrar contenido destacado para carruseles de página de inicio",
      "empty": "Sin contenido destacado",
      "emptyHint": "Los elementos destacados aparecerán en sus respectivos carruseles en la página de inicio",
      "count": "{{count}} elementos",
      "confirmUnfeature": "¿Quitar de destacado?",
      "remove": "Quitar",
      "unsavedChanges": "Tienes cambios sin guardar",
      "section": {
        "title": "{{name}}",
        "itemCount": "{{count}} elemento",
        "itemCount_plural": "{{count}} elementos",
        "empty": "Sin elementos destacados",
        "emptyHint": "Los elementos destacados aparecerán en el carrusel {{name}} en la página de inicio"
      },
      "saveButton": "Guardar {{count}} Sección",
      "saveButton_plural": "Guardar {{count}} Secciones",
      "saving": "Guardando...",
      "saveSuccess": "Contenido destacado actualizado correctamente",
      "saveFailed": "Error al guardar contenido destacado",
      "removeConfirm": "¿Quitar de {{section}}?",
      "removeSuccess": "Removido de {{section}}"
    },
    "recordings": {
      "title": "Gestión de Grabaciones",
      "subtitle": "Administrar grabaciones de usuarios en la plataforma",
      "totalRecordings": "Total de Grabaciones",
      "totalStorage": "Almacenamiento Total",
      "totalUsers": "Usuarios con Grabaciones",
      "activeSessions": "Sesiones Activas",
      "searchPlaceholder": "Buscar por título, usuario o canal...",
      "user": "Usuario",
      "confirmDelete": "¿Eliminar grabación '{{title}}'? Esta acción no se puede deshacer.",
      "deleteRecording": "Eliminar Grabación",
      "deleteSuccess": "Grabación eliminada exitosamente",
      "deleteFailed": "Error al eliminar grabación",
      "loadFailed": "Error al cargar grabaciones",
      "noRecordings": "No Se Encontraron Grabaciones",
      "noRecordingsHint": "No hay grabaciones de usuarios en el sistema aún."
    },
    "uploads": {
      "title": "Gestión de Cargas",
      "subtitle": "Administrar cargas de contenido y monitoreo automático de carpetas",
      "activeUploads": "Cargas Activas",
      "noActiveUploads": "No hay cargas activas",
      "queuedUploads": "Cargas en Cola",
      "queued": "En Cola",
      "andMore": "Y {{count}} más",
      "monitoredFolders": "Carpetas Monitoreadas",
      "noMonitoredFolders": "No hay carpetas monitoreadas configuradas",
      "configureFoldersHelp": "Haga clic en 'Agregar Carpeta' para configurar carpetas monitoreadas para cargas automáticas",
      "addFolder": "Agregar Carpeta",
      "editFolder": "Editar Carpeta",
      "deleteFolder": "Eliminar Carpeta",
      "confirmDelete": "¿Eliminar esta carpeta?",
      "triggerUpload": "Activar Carga",
      "triggerUploadSuccess": "Escaneo de carga activado exitosamente",
      "triggerUploadFailed": "Error al activar escaneo de carga",
      "noFilesFound": "No se encontraron archivos nuevos en las carpetas monitoreadas",
      "sessionIssue": "Problema de sesión",
      "sessionIssueHelp": "Su sesión puede haber expirado. Actualice la página para restaurar la conexión.",
      "sessionExpired": "La sesión ha expirado. Actualice la página o inicie sesión de nuevo.",
      "unauthorized": "Sesión inválida. Actualice la página.",
      "endpointNotFound": "Servicio de carga no disponible. Verifique la configuración del servidor.",
      "timeout": "El escaneo de carga agotó el tiempo. Inténtelo de nuevo o verifique las carpetas monitoreadas.",
      "wsDisconnected": "Actualizaciones en tiempo real deshabilitadas",
      "wsDisconnectedHelp": "La conexión WebSocket falló. El estado de la cola puede estar desactualizado. La página reintentará automáticamente.",
      "wsReconnecting": "Reconectando a las actualizaciones en tiempo real...",
      "uploadAlreadyRunning": "Ya hay un escaneo de carga en curso. Espere a que se completen las cargas actuales.",
      "uploadsActiveNotice": "Cargas en progreso ({{processing}} activas, {{queued}} en cola). Nuevo escaneo deshabilitado hasta que se complete el lote actual.",
      "clearQueue": "Limpiar Cola",
      "clearQueueConfirmTitle": "¿Limpiar Cola de Carga?",
      "clearQueueConfirmMessage": "Esto cancelará {{count}} trabajo(s) activo(s). Esta acción no se puede deshacer.",
      "clearQueueSuccess": "Cola limpiada exitosamente",
      "clearQueueFailed": "Error al limpiar la cola",
      "cancelUpload": "Cancelar",
      "cancelUploadConfirm": "¿Cancelar esta carga?",
      "cancelUploadSuccess": "Carga cancelada",
      "cancelUploadFailed": "No se pudo cancelar la carga",
      "resetCache": "Restablecer Caché",
      "cacheResetSuccess": "Caché limpiada: {{count}} archivos se escanearán nuevamente en el próximo escaneo",
      "cacheResetFailed": "Error al restablecer la caché",
      "contentTypeFilters": "Filtros de tipo de contenido",
      "contentTypeFiltersHelp": "Opcional - Deje todo sin marcar para procesar todos los tipos de contenido",
      "moviesOnly": "Solo películas",
      "seriesOnly": "Solo series",
      "audiobooksOnly": "Solo audiolibros",
      "type": "Tipo",
      "lastScan": "Último escaneo",
      "systemInfo": "Información del Sistema de Carga",
      "systemInfoText": "Extrae automáticamente subtítulos de archivos de video locales durante la carga para un procesamiento más rápido",
      "languagesInfo": "Idiomas de subtítulos compatibles: Inglés (en), Hebreo (he), Español (es)",
      "queueStatus": "Cola de Carga",
      "totalJobs": "Total",
      "processing": "Activo",
      "completed": "Completado",
      "skipped": "Omitido",
      "failed": "Fallido",
      "queuePaused": "Cola Pausada",
      "resumeQueue": "Reanudar",
      "activeUpload": "Carga Activa",
      "queuedItems": "En Cola",
      "noQueuedItems": "No hay elementos en cola",
      "addedAt": "Agregado",
      "recentCompleted": "Completados Recientemente",
      "stages": {
        "browserUpload": "Subiendo al servidor",
        "hashCalculation": "Calculando hash",
        "duplicateCheck": "Verificando duplicados",
        "metadataExtraction": "Extrayendo metadatos",
        "gcsUpload": "Subiendo a la nube",
        "databaseInsert": "Guardando en la base de datos",
        "imdbLookup": "Obteniendo información de IMDB",
        "subtitleExtraction": "Extrayendo subtítulos",
        "completed": "Completado",
        "failed": "Fallido",
        "skipped": "Omitido"
      },
      "form": {
        "name": "Nombre de Carpeta",
        "namePlaceholder": "Mi Carpeta de Películas",
        "path": "Ruta de Carpeta",
        "pathHelp": "Ingrese la ruta del servidor a la carpeta (ej., /Volumes/USB Drive/Movies)",
        "contentType": "Tipo de Contenido",
        "enabled": "Habilitado",
        "autoUpload": "Carga Automática"
      },
      "contentTypes": {
        "movie": "Películas",
        "series": "Series",
        "audiobook": "Audiolibros"
      },
      "errors": {
        "pathRequired": "La ruta de la carpeta es obligatoria"
      },
      "manualUpload": {
        "title": "Carga Manual",
        "subtitle": "Arrastra y suelta archivos o selecciona una carpeta",
        "dropHere": "Suelta archivos aquí o haz clic para explorar",
        "dropHereActive": "Suelta los archivos para agregarlos",
        "selectFolder": "Seleccionar Carpeta",
        "supportedFormats": "Soporta archivos de video (mp4, mkv, avi, mov, webm)",
        "selectedFiles": "Archivos Seleccionados",
        "noFilesSelected": "No hay archivos seleccionados",
        "clearAll": "Limpiar Todo",
        "uploadSelected": "Subir Seleccionados",
        "selectContentType": "Selecciona el tipo de contenido para cargar",
        "uploadingFiles": "Agregando {{count}} archivo(s) a la cola...",
        "uploadSuccess": "Se agregaron {{count}} archivo(s) a la cola exitosamente",
        "uploadFailed": "Error al agregar archivos a la cola",
        "fileSize": "Tamaño",
        "removeFile": "Eliminar",
        "invalidFileType": "Tipo de archivo no válido. Solo se admiten archivos de video.",
        "filesCount": "{{count}} archivo(s) seleccionado(s)",
        "pendingRestore": "{{count}} archivo(s) pendiente(s) de sesión anterior",
        "pendingRestoreHint": "Arrastra o selecciona los mismos archivos para restaurar la cola de carga"
      }
    },
    "librarian": {
      "title": "Agente Bibliotecario",
      "subtitle": "Gestión autónoma de biblioteca de contenido con IA",
      "loading": "Cargando Agente Bibliotecario...",
      "loadingConfig": "Cargando configuración...",
      "refresh": "Actualizar",
      "errors": {
        "configError": "Error de Configuración",
        "configNotLoaded": "Configuración no cargada",
        "failedToLoad": "Error al cargar datos del bibliotecario",
        "failedToLoadConfig": "Error al cargar configuración del bibliotecario",
        "failedToTrigger": "Error al activar auditoría. Por favor, inténtalo de nuevo.",
        "failedToLoadDetails": "Error al cargar detalles del informe.",
        "failedToRollback": "Error al revertir acción.",
        "failedToClearReports": "No se pudieron borrar los informes de auditoría. Inténtelo de nuevo.",
        "failedToPause": "Error al pausar auditoría",
        "failedToResume": "Error al reanudar auditoría",
        "failedToCancel": "Error al cancelar auditoría",
        "failedToInterject": "Error al enviar mensaje al agente AI",
        "auditAlreadyRunning": "Ya se está ejecutando una auditoría. Espere a que termine o cancélela antes de iniciar una nueva.",
        "budgetExceeded": "Límite de presupuesto mensual excedido. No se puede ejecutar auditoría.",
        "contactAdmin": "La página del Bibliotecario no puede cargarse sin la configuración adecuada.\nPor favor, contacta a tu administrador."
      },
      "stats": {
        "systemHealth": "Estado del Sistema",
        "totalAudits": "Total de Auditorías (30d)",
        "last30Days": "Últimos 30 días",
        "issuesFixed": "Problemas Resueltos",
        "lastAudit": "Última Auditoría",
        "never": "Nunca",
        "unknown": "desconocido"
      },
      "health": {
        "excellent": "excelente",
        "good": "bueno",
        "fair": "regular",
        "poor": "pobre",
        "unknown": "desconocido"
      },
      "quickActions": {
        "title": "Configuración de Ejecución",
        "subtitle": "Configurar y activar auditorías",
        "auditMode": "Modo de auditoría",
        "auditModeHelp": "Elija qué verificar",
        "dryRun": "Modo Vista Previa",
        "dryRunHelp": "Mostrar qué cambiaría sin realizar cambios",
        "scopeFilters": "Capacidades de Auditoría",
        "scopeFiltersHelp": "Seleccionar capacidades a habilitar (se pueden combinar varias)",
        "last24Hours": "Contenido Reciente",
        "last24HoursHelp": "Limitar auditoría al contenido añadido en las últimas 24 horas",
        "cybTitlesOnly": "Limpiar Títulos Sucios",
        "cybTitlesOnlyHelp": "Eliminar extensiones de archivo, marcadores de calidad y etiquetas de los títulos",
        "tmdbPostersOnly": "Pósters y Metadatos TMDB",
        "tmdbPostersOnlyHelp": "Obtener pósters, descripciones y metadatos faltantes de TMDB",
        "openSubtitlesEnabled": "Adquirir Subtítulos",
        "openSubtitlesEnabledHelp": "Descargar subtítulos faltantes de OpenSubtitles (HE/EN/ES)",
        "classifyOnly": "Verificar Clasificación",
        "classifyOnlyHelp": "Verificar y corregir errores de clasificación película vs serie",
        "purgeDuplicates": "Eliminar Duplicados",
        "purgeDuplicatesHelp": "Encontrar y eliminar contenido duplicado",
        "auditType": "Tipo de auditoría",
        "auditTypeHelp": "Elija entre auditoría basada en reglas o impulsada por IA",
        "dailyAudit": "Auditoría diaria",
        "dailyBadge": "Basado en reglas - Rápido - Gratuito",
        "dailyDescription": "Ejecuta verificaciones predefinidas en contenido modificado en los últimos 7 días. Rápido y predecible, sin costos de IA.",
        "aiAgentAudit": "Auditoría con agente IA",
        "aiAgentBadge": "Impulsado por IA - Inteligente - Consume presupuesto",
        "aiAgentDescription": "El agente de IA autónomo (Claude) toma decisiones inteligentes sobre qué verificar y corregir. Más completo pero consume presupuesto de API.",
        "triggerDaily": "Activar Auditoría Diaria",
        "triggerAI": "Activar Auditoría de Agente IA",
        "auditRunningNotice": "Se está ejecutando una auditoría. Los botones se habilitarán cuando termine.",
        "budgetLabel": "Límite de Presupuesto del Agente IA: ${{budget}}",
        "budgetPerAudit": "Presupuesto por Auditoría",
        "monthlyBudgetUsed": "Presupuesto Usado (30d)",
        "monthlyBudgetLimit": "/ ${{limit}} mensual",
        "budgetWarning": "Ejecutar esta auditoría excedería el límite de presupuesto mensual",
        "aiAuditSuccess": "Auditoría de Agente IA activada exitosamente. {{dryRun}}",
        "dailyAuditSuccess": "Auditoría diaria activada exitosamente. {{dryRun}}",
        "dryRunMode": "(Modo de ejecución simulada)",
        "rollbackSuccess": "Acción revertida exitosamente."
      },
      "voice": {
        "title": "Control por Voz",
        "description": "Usa tu voz para dar comandos al bibliotecario. Solo presiona el botón y habla naturalmente.",
        "pressToSpeak": "Presiona para Hablar",
        "listening": "Escuchando...",
        "transcript": "Transcripción",
        "processing": "Procesando tu comando...",
        "speaking": "El bibliotecario está respondiendo...",
        "examples": "Comandos de Ejemplo",
        "example1": "Verifica pósters faltantes en las últimas 24 horas",
        "example2": "Corrige metadatos para títulos CYB",
        "example3": "Escanea URLs de transmisión rotas",
        "example4": "Extrae subtítulos de películas",
        "notSupported": "El reconocimiento de voz no es compatible con tu navegador. Por favor usa Chrome, Edge o Safari.",
        "notAvailable": "El control por voz no está disponible",
        "noSpeech": "No se detectó habla. Por favor intenta de nuevo.",
        "noMicrophone": "No se detectó micrófono. Por favor verifica tu dispositivo.",
        "microphoneBlocked": "El acceso al micrófono fue bloqueado. Por favor habilítalo en la configuración de tu navegador.",
        "error": "Error de reconocimiento de voz: {{error}}",
        "startFailed": "Falló al iniciar el reconocimiento de voz. Por favor intenta de nuevo.",
        "commandFailed": "Falló al ejecutar el comando. Por favor intenta de nuevo."
      },
      "schedules": {
        "title": "Auditorías Programadas",
        "subtitle": "Configure programaciones de auditoría diarias y semanales",
        "dailyTitle": "Auditoría Diaria",
        "weeklyTitle": "Auditoría IA Semanal",
        "schedule": "Programación",
        "time": "Hora",
        "mode": "Modo",
        "cost": "Costo Est.",
        "status": "Estado",
        "description": "Descripción",
        "viewInConsole": "Ver en Cloud Console",
        "modifyNote": "Para modificar programaciones, usa Google Cloud Console",
        "editTitle": "Editar Programación",
        "editNotAvailable": "Edición de Programaciones No Disponible",
        "editNotAvailableMessage": "Las modificaciones de programaciones requieren integración con la API de Cloud Scheduler. Por favor, use el botón 'Ver en Cloud Console' para modificar programaciones directamente en Google Cloud Console.",
        "cronExpression": "Expresión Cron",
        "cronHint": "Formato: minuto hora día mes díaSemana (ej., 0 2 * * * = diario a las 2:00 AM)",
        "patterns": {
          "daily": "Diario a las {{hour}}:{{minute}}",
          "weekly": "Cada {{day}} a las {{hour}}:{{minute}}"
        },
        "days": {
          "sunday": "domingo",
          "monday": "lunes",
          "tuesday": "martes",
          "wednesday": "miércoles",
          "thursday": "jueves",
          "friday": "viernes",
          "saturday": "sábado"
        }
      },
      "reports": {
        "title": "Informes de Auditoría Recientes",
        "emptyMessage": "Aún no hay informes de auditoría",
        "totalReports": "{{count}} informe(s)",
        "clearAll": "Limpiar Todo",
        "confirmClearAll": "¿Está seguro de que desea borrar todos los informes de auditoría? Esta acción no se puede deshacer.",
        "clearedSuccessfully": "Todos los informes de auditoría se han borrado exitosamente",
        "viewLogs": "Ver Registros",
        "viewDetails": "Ver Detalles",
        "columns": {
          "date": "Fecha",
          "type": "Tipo",
          "duration": "Duración",
          "status": "Estado",
          "issues": "Problemas",
          "fixes": "Correcciones",
          "actions": "Acciones"
        },
        "detailModal": {
          "title": "Informe de Auditoría: {{id}}",
          "summary": "Resumen",
          "status": "Estado",
          "executionTime": "Tiempo de Ejecución",
          "totalItems": "Total de Elementos",
          "healthyItems": "Elementos Saludables",
          "issuesFound": "Problemas Encontrados",
          "totalIssues": "Total de Problemas Encontrados",
          "seeInsightsBelow": "Ver Perspectivas de IA abajo para más detalles",
          "brokenStreams": "Transmisiones Rotas",
          "missingMetadata": "Metadatos Faltantes",
          "misclassifications": "Clasificaciones Erróneas",
          "orphanedItems": "Elementos Huérfanos",
          "fixesApplied": "Correcciones Aplicadas",
          "totalFixes": "{{count}} correcciones totales",
          "aiInsights": "Perspectivas de IA"
        }
      },
      "logs": {
        "title": "Registros de Ejecución",
        "liveAuditLog": "Registro de Auditoría en Vivo",
        "executionLog": "Registro de Ejecución de Auditoría",
        "searchPlaceholder": "Buscar registros...",
        "noLogs": "No hay registros para mostrar",
        "noActiveAudit": "No hay Auditoría Activa",
        "triggerAuditToSee": "Activa una auditoría para ver los registros de ejecución en vivo aquí",
        "auditType": "Tipo de Auditoría",
        "started": "Iniciado",
        "completed": "Completado",
        "lastLog": "Último registro",
        "staleWarning": "Sin nuevos registros durante {{seconds}}s - el trabajo puede estar procesando o atascado",
        "pollingStatus": "Sondeo activo - Última verificación",
        "connecting": "Conectando al registro de auditoría en vivo...",
        "aiInsightPrefix": "Perspectiva de IA",
        "source": {
          "librarian": "Bibliotecario",
          "aiAgent": "Agente de IA"
        },
        "levels": {
          "debug": "DEPURACIÓN",
          "info": "INFO",
          "warn": "AVISO",
          "error": "ERROR",
          "success": "ÉXITO",
          "trace": "TRAZA"
        },
        "auditStarted": "Auditoría iniciada",
        "brokenStreamsFound": "Se encontraron {{count}} transmisión(es) rota(s)",
        "missingMetadataFound": "Se encontraron {{count}} elemento(s) con metadatos faltantes",
        "misclassificationsFound": "Se encontraron {{count}} elemento(s) mal clasificado(s)",
        "orphanedItemsFound": "Se encontraron {{count}} elemento(s) huérfano(s)",
        "fixesApplied": "Se aplicaron {{count}} corrección(es)",
        "auditCompleted": "Auditoría {{status}} en {{duration}}s",
        "auditInitializing": "🚀 Inicializando auditoría {{auditType}}...",
        "dryRunMode": "⚠️ Ejecutando en modo PRUEBA - no se realizarán cambios",
        "liveMode": "✅ Ejecutando en modo EN VIVO - se aplicarán cambios",
        "budgetSet": "💰 Límite de presupuesto: ${{budget}}",
        "connectingToAgent": "🔗 Conectando al Agente Claude AI..."
      },
      "audit": {
        "types": {
          "aiAgent": "Agente AI",
          "dailyIncremental": "Incremental Diario"
        },
        "pause": "Pausar",
        "resume": "Reanudar",
        "cancel": "Cancelar",
        "interject": "Intervenir",
        "interjectTitle": "Enviar Mensaje al Agente AI",
        "interjectHint": "Este mensaje se inyectará en la conversación del agente AI en la próxima iteración. Úsalo para proporcionar contexto adicional, redirigir el enfoque o dar instrucciones específicas.",
        "interjectPlaceholder": "ej., Enfócate solo en películas, omite series por ahora...",
        "sendInterject": "Enviar",
        "interjectSuccess": "Mensaje enviado al agente AI exitosamente",
        "pauseSuccess": "Auditoría pausada exitosamente",
        "resumeSuccess": "Auditoría reanudada exitosamente",
        "cancelSuccess": "Auditoría cancelada exitosamente"
      },
      "progress": {
        "batch": "Lote {{current}} de {{total}}",
        "items": "{{processed}} de {{total}} elementos",
        "finishing": "Finalizando...",
        "finalizing": "Generando informe y aplicando correcciones"
      },
      "activityLog": {
        "title": "Registro de Actividad",
        "subtitle": "{{count}} acciones registradas",
        "filterByType": "Filtrar por tipo",
        "allActions": "Todas las Acciones",
        "content": "Contenido",
        "noDescription": "No hay descripción disponible",
        "updatedFields": "Actualizado {{fields}}",
        "pagination": "Página {{page}} de {{totalPages}}",
        "issueType": "Tipo de Problema",
        "confidence": "Confianza",
        "autoApproved": "Auto-aprobado",
        "changes": "Cambios",
        "actionTypes": {
          "addPoster": "Agregar Póster",
          "updateMetadata": "Actualizar Metadatos",
          "recategorize": "Recategorizar",
          "fixUrl": "Corregir URL",
          "cleanTitle": "Limpiar Título",
          "classify": "Clasificar"
        },
        "rollback": "Revertir",
        "rolledBack": "Revertido",
        "confirmRollback": {
          "title": "Confirmar Reversión",
          "message": "¿Estás seguro de que quieres revertir esta acción? Esto restaurará el estado anterior."
        },
        "emptyMessage": "No se encontraron acciones"
      },
      "modal": {
        "confirmAI": {
          "title": "¿Activar Auditoría de Agente IA?",
          "message": "Esto activará una auditoría autónoma de agente IA con un límite de presupuesto de ${{budget}}. El agente tomará decisiones sobre qué verificar y corregir. {{dryRun}}",
          "dryRunNote": "Ejecutando en modo SIMULADO (no se realizarán cambios)."
        },
        "cancel": "Cancelar",
        "confirm": "Confirmar",
        "close": "Cerrar",
        "retry": "Reintentar"
      },
      "status": {
        "enabled": "HABILITADO",
        "disabled": "DESHABILITADO",
        "completed": "completado",
        "failed": "fallido",
        "in_progress": "en_progreso",
        "partial": "Parcialmente completado",
        "pending": "pendiente",
        "running": "En ejecución"
      },
      "auditTypes": {
        "daily_incremental": "incremental diario",
        "ai_agent": "Agente IA"
      }
    },
    "widgets": {
      "title": "Widgets",
      "subtitle": "Gestiona widgets de superposición flotante para transmisiones en vivo e incrustaciones",
      "newWidget": "Nuevo Widget",
      "editWidget": "Editar Widget",
      "columns": {
        "title": "Título",
        "contentType": "Tipo de Contenido",
        "targetRoles": "Roles Objetivo",
        "targetPages": "Páginas de Destino",
        "status": "Estado",
        "order": "Orden"
      },
      "contentTypes": {
        "liveChannel": "Canal en Vivo",
        "live": "En vivo",
        "vod": "Video bajo Demanda",
        "podcast": "Pódcast",
        "radio": "Radio",
        "iframe": "Iframe"
      },
      "status": {
        "active": "Activo",
        "inactive": "Inactivo"
      },
      "form": {
        "title": "Título del widget",
        "description": "Descripción (opcional)",
        "icon": "Emoji de ícono (opcional)",
        "contentType": "Tipo de Contenido",
        "selectChannel": "Seleccionar Canal en Vivo",
        "channelPlaceholder": "-- Seleccionar Canal --",
        "iframeUrl": "URL del iframe",
        "iframeTitle": "Título del iframe (para accesibilidad)",
        "position": "Posición Predeterminada",
        "behavior": "Comportamiento",
        "mutedByDefault": "Silenciado por defecto",
        "closable": "Cerrable",
        "draggable": "Arrastrable",
        "targetPages": "Páginas Objetivo (separadas por comas, vacío = todas)",
        "targetPagesPlaceholder": "/, /en vivo, /vídeo bajo demanda",
        "order": "Pedido"
      },
      "actions": {
        "save": "Guardar",
        "cancel": "Cancelar"
      },
      "confirmDelete": "¿Estás seguro de que quieres eliminar este widget?",
      "emptyMessage": "No se encontraron widgets. Crea uno para comenzar.",
      "allPages": "Todas las páginas",
      "allRoles": "Todo",
      "errors": {
        "titleRequired": "El título es obligatorio",
        "selectChannel": "Por favor selecciona un canal en vivo",
        "iframeUrlRequired": "Se requiere la URL del iframe"
      }
    },
    "billing": {
      "subtitle": "Rastrear ingresos y pagos",
      "revenue": "Ingresos",
      "today": "Hoy",
      "thisWeek": "Esta Semana",
      "thisMonth": "Este Mes",
      "thisYear": "Este Año",
      "metrics": "Métricas Clave",
      "totalTransactions": "Total de Transacciones",
      "avgTransaction": "Transacción Promedio",
      "pendingRefunds": "Reembolsos Pendientes",
      "refundRate": "Tasa de Reembolso",
      "retention": "Retención",
      "retentionRate": "Tasa de Retención",
      "churnRate": "Tasa de Abandono",
      "atRiskUsers": "Usuarios en Riesgo",
      "churnedUsers": "Usuarios Perdidos",
      "quickLinks": "Enlaces Rápidos"
    },
    "marketing": {
      "recentCampaigns": "Campañas Recientes",
      "audienceSegments": "Segmentos de Audiencia",
      "emailMetrics": "Métricas de Correo",
      "pushMetrics": "Métricas de Push",
      "quickActions": "Acciones Rápidas"
    },
    "push": {
      "titlePlaceholder": "Título de Notificación",
      "bodyPlaceholder": "Mensaje de Notificación"
    },
    "auditLogs": {
      "subtitle": "Rastrear todas las acciones del sistema",
      "filter": "Filtro",
      "export": "Exportar",
      "all": "Todo",
      "advancedFiltering": "Filtrado Avanzado",
      "actionType": "Tipo de Acción",
      "clear": "Limpiar",
      "apply": "Aplicar",
      "noRecords": "No se encontraron registros",
      "columns": {
        "action": "Acción",
        "user": "Usuario",
        "resource": "Recurso",
        "details": "Detalles",
        "date": "Fecha",
        "ip": "IP"
      },
      "changed": "Cambiado",
      "actionFilters": {
        "user": "Usuario",
        "subscription": "Suscripción",
        "payment": "Pago",
        "settings": "Configuración",
        "campaign": "Campaña",
        "content": "Contenido"
      }
    },
    "settings": {
      "subtitle": "Configurar parámetros del sistema",
      "saveChanges": "Guardar Cambios",
      "generalSettings": "Configuración General",
      "supportEmail": "Email de Soporte",
      "defaultPlan": "Plan Predeterminado",
      "termsUrl": "URL de Términos del Servicio",
      "privacyUrl": "URL de Política de Privacidad",
      "userSettings": "Configuración de Usuario",
      "maxDevices": "Máximo de Dispositivos por Cuenta",
      "trialDays": "Días del Período de Prueba",
      "maintenanceMode": "Modo de Mantenimiento",
      "maintenanceModeDesc": "Cuando esté habilitado, el sistema será inaccesible para los usuarios",
      "featureFlags": "Banderas de Funcionalidad",
      "systemActions": "Acciones del Sistema",
      "clearCache": "Borrar Caché",
      "resetAnalytics": "Restablecer Analytics",
      "actionsWarning": "Estas acciones pueden afectar el rendimiento del sistema. Úselas con precaución.",
      "savingSuccess": "Configuración guardada exitosamente",
      "confirmClearCache": "¿Limpiar caché? Esto puede afectar temporalmente el rendimiento.",
      "cacheCleared": "Caché eliminado correctamente",
      "confirmResetAnalytics": "¿Restablecer datos analíticos? ¡Esta acción no se puede deshacer!",
      "analyticsReset": "Los datos de analíticas han sido restablecidos",
      "featureFlagLabels": {
        "new_player": "Jugador Nuevo",
        "live_chat": "Chat en Vivo",
        "downloads": "Descargas",
        "watch_party": "Fiesta de visualización",
        "voice_search": "Búsqueda por voz",
        "ai_recommendations": "Recomendaciones de IA"
      }
    },
    "content": {
      "title": "Biblioteca de Contenido",
      "subtitle": "Gestionar películas, series y contenido de video",
      "importFree": "Importar Contenido Gratuito",
      "searchPlaceholder": "Buscar contenido...",
      "emptyMessage": "No se encontró contenido",
      "confirmDelete": "¿Eliminar este contenido?",
      "confirmBatchDelete": "¿Está seguro de que desea eliminar {{count}} elemento(s)?",
      "selectedItems": "{{count}} elemento(s) seleccionado(s)",
      "batchFeature": "Destacar",
      "batchUnfeature": "Quitar destacado",
      "import": {
        "pageTitle": "Importar Contenido Gratuito",
        "subtitle": "Explorar e importar contenido público de fuentes gratuitas",
        "selectCategory": "Selecciona categoría para películas importadas:",
        "categoryPlaceholder": "Selecciona una categoría...",
        "loading": "Cargando fuentes...",
        "sourceTypes": {
          "vod": "Películas y VOD",
          "live_tv": "TV en vivo",
          "radio": "Radio",
          "podcasts": "Pódcasts"
        },
        "items": "artículo",
        "itemsPlural": "artículos",
        "selectItems": "Por favor selecciona al menos un elemento para importar",
        "selectCategory_vod": "Por favor selecciona una categoría para las importaciones de VOD",
        "importing": "Importando {{count}}... {{percent}}%",
        "importButton": "Importar {{count}} {{item}}",
        "noSources": "No hay fuentes disponibles",
        "noSourcesDescription": "No hay fuentes de contenido gratuito disponibles actualmente para {{type}}"
      },
      "filters": {
        "title": "Filtros",
        "contentType": "Tipo de Contenido",
        "all": "Todo",
        "allContent": "Todo",
        "series": "Series",
        "movies": "Películas",
        "podcasts": "Podcasts",
        "radioStations": "Estaciones de Radio",
        "status": "Estado",
        "allStatus": "Todos los Estados",
        "subtitles": "Subtítulos"
      },
      "podcastsComingSoon": "Gestión de podcasts próximamente. Use la sección de Podcasts.",
      "radioComingSoon": "Gestión de estaciones de radio próximamente. Use la sección de Estaciones de Radio.",
      "showOnlyWithSubtitles": "Mostrar solo con subtítulos",
      "status": {
        "published": "Publicado",
        "draft": "Borrador"
      },
      "columns": {
        "title": "Título",
        "category": "Categoría",
        "year": "Año",
        "status": "Estado",
        "views": "Vistas",
        "rating": "Calificación",
        "streamUrl": "URL de transmisión",
        "epgSource": "Fuente EPG",
        "genre": "Género",
        "episodeNumber": "Episodio #",
        "description": "Descripción",
        "duration": "Duración",
        "publishedDate": "Publicado",
        "episodes": "Episodios",
        "order": "Pedido",
        "name": "Nombre",
        "slug": "Babosa",
        "subtitles": "Subtítulos"
      },
      "validation": {
        "titleRequired": "El título es obligatorio",
        "nameRequired": "El nombre es obligatorio",
        "streamUrlRequired": "La URL del stream es obligatoria",
        "audioUrlRequired": "La URL de audio es obligatoria"
      },
      "episodes_one": "episodio",
      "episodes_other": "episodios",
      "noEpisodes": "No se encontraron episodios",
      "type": {
        "series": "Serie",
        "movie": "Película"
      },
      "toggleCarousel": "Alternar carrusel",
      "editor": {
        "pageTitle": "Editar Contenido",
        "pageTitleNew": "Agregar Contenido",
        "sections": {
          "basicInfo": "Información Básica",
          "media": "Medios",
          "streaming": "Transmisión",
          "details": "Detalles del Contenido",
          "publishing": "Publicación",
          "accessControl": "Control de Acceso",
          "podcastDetails": "Detalles del Podcast",
          "episodeDetails": "Detalles del Episodio",
          "stationDetails": "Detalles de la Estación",
          "channelDetails": "Detalles del Canal"
        },
        "fields": {
          "title": "Título",
          "titlePlaceholder": "Título del contenido",
          "titleRequired": "El título es obligatorio",
          "year": "Año",
          "yearPlaceholder": "2024",
          "description": "Descripción",
          "descriptionPlaceholder": "Descripción del contenido",
          "thumbnail": "Miniatura (relación 3:4)",
          "thumbnailUrl": "URL de Miniatura",
          "thumbnailUrlPlaceholder": "https://ejemplo.com/miniatura.jpg",
          "backdrop": "Fondo (relación 16:9)",
          "backdropUrl": "URL de Fondo",
          "posterCover": "Portada del Podcast",
          "logo": "Logo",
          "channelLogo": "Logo del Canal",
          "stationLogo": "Logo de la Estación",
          "streamUrl": "URL de Transmisión",
          "streamUrlRequired": "La URL de transmisión es obligatoria",
          "streamType": "Tipo de Transmisión",
          "drmProtected": "Protegido con DRM",
          "drmProtectedLabel": "Este contenido requiere protección DRM",
          "category": "Categoría",
          "categoryRequired": "La categoría es obligatoria",
          "duration": "Duración",
          "durationPlaceholder": "1:30:00",
          "rating": "Clasificación",
          "ratingPlaceholder": "PG-13",
          "genre": "Género",
          "genrePlaceholder": "Drama",
          "director": "Director",
          "directorPlaceholder": "Nombre del director",
          "isSeries": "Serie",
          "isSeriesLabel": "Este es una serie/contenido multi-parte",
          "season": "Temporada",
          "episode": "Episodio",
          "seriesId": "ID de Serie",
          "seriesIdPlaceholder": "identificador-serie",
          "isPublished": "Publicar",
          "isPublishedLabel": "Publicar este contenido inmediatamente",
          "isFeatured": "Destacar",
          "isFeaturedLabel": "Destacar este contenido en la página principal",
          "requiresSubscription": "Suscripción Requerida",
          "isKidsContent": "Contenido Infantil",
          "isKidsContentLabel": "Este es contenido apto para niños",
          "author": "Autor",
          "authorPlaceholder": "Autor del podcast",
          "podcastCategory": "Categoría",
          "podcastCategoryPlaceholder": "Noticias, Ciencia, etc.",
          "rssFeed": "URL del Feed RSS",
          "rssFeedPlaceholder": "https://ejemplo.com/feed.xml",
          "website": "URL del Sitio Web",
          "websitePlaceholder": "https://ejemplo.com",
          "episodeNumber": "Episodio #",
          "seasonNumber": "Temporada #",
          "audioUrl": "URL de Audio",
          "audioUrlRequired": "La URL de audio es obligatoria",
          "audioUrlPlaceholder": "https://ejemplo.com/episodio.mp3",
          "publishedAt": "Fecha de Publicación",
          "epgSource": "URL de Fuente EPG",
          "epgSourcePlaceholder": "https://ejemplo.com/epg.xml",
          "currentShow": "Programa Actual",
          "currentShowPlaceholder": "Nombre del programa",
          "nextShow": "Próximo Programa",
          "nextShowPlaceholder": "Nombre del programa",
          "currentSong": "Canción Actual",
          "currentSongPlaceholder": "Título de la canción",
          "isActive": "Activo",
          "isActiveLabel": "El canal está activo",
          "requiredSubscription": "Suscripción Requerida",
          "publishedDate": "Fecha de Publicación"
        },
        "subscriptionTiers": {
          "basic": "Básico",
          "premium": "Premium",
          "family": "Familiar"
        },
        "actions": {
          "save": "Guardar",
          "saving": "Guardando...",
          "cancel": "Cancelar"
        },
        "imageUpload": {
          "dropHere": "Suelta la imagen aquí o haz clic para cargar",
          "formats": "PNG, JPG, WebP hasta {{maxSize}}MB",
          "uploading": "Subiendo...",
          "success": "Imagen subida exitosamente",
          "orPasteUrl": "O pega la URL de la imagen",
          "urlPlaceholder": "https://ejemplo.com/imagen.jpg",
          "validateButton": "Agregar",
          "validating": "Validando...",
          "clear": "Eliminar imagen",
          "errors": {
            "imageOnly": "Por favor selecciona un archivo de imagen",
            "tooLarge": "El tamaño del archivo debe ser menor a {{maxSize}}MB",
            "uploadFailed": "La carga falló",
            "invalidUrl": "URL inválida"
          }
        }
      },
      "categoryPicker": {
        "selectPlaceholder": "Seleccionar categoría...",
        "searchPlaceholder": "Buscar categorías...",
        "loading": "Cargando categorías...",
        "noResults": "No se encontraron categorías",
        "noCategories": "No hay categorías disponibles",
        "createNew": "Crear nueva categoría",
        "errors": {
          "loadFailed": "Error al cargar las categorías",
          "createFailed": "Error al crear la categoría"
        },
        "modal": {
          "title": "Crear Nueva Categoría",
          "placeholder": "Nombre de la categoría (ej: Películas, Series)",
          "creating": "Creando...",
          "create": "Crear"
        }
      },
      "streamUrlInput": {
        "copyUrl": "Copiar URL",
        "copied": "URL copiada al portapapeles",
        "streamType": "Tipo de Transmisión",
        "validUrl": "URL válida - detectada como {{type}}",
        "errors": {
          "required": "Se requiere la URL de transmisión",
          "invalidFormat": "Formato de URL inválido"
        },
        "supportedFormats": {
          "title": "Formatos soportados:",
          "hls": "HLS: transmisiones .m3u8",
          "dash": "DASH: transmisiones .mpd",
          "audio": "Audio: transmisiones .mp3, .aac o audio"
        }
      }
    },
    "categories": {
      "subtitle": "Administrar categorías de contenido",
      "emptyMessage": "No se encontraron categorías",
      "status": {
        "active": "Activo",
        "inactive": "Inactivo"
      },
      "form": {
        "nameHebrew": "Nombre de categoría (hebreo)",
        "nameEnglish": "Nombre de categoría (inglés)",
        "slug": "Slug"
      }
    },
    "liveChannels": {
      "subtitle": "Administrar canales de TV en vivo",
      "emptyMessage": "No se encontraron canales en vivo",
      "subtitleSettings": "Configuración de subtítulos en vivo",
      "form": {
        "name": "Nombre del canal",
        "streamUrl": "URL de transmisión",
        "epgSource": "URL de fuente EPG (opcional)",
        "currentShow": "Programa actual",
        "order": "Orden",
        "supportsSubtitles": "Habilitar subtítulos en vivo",
        "primaryLanguage": "Idioma principal (origen)",
        "targetLanguages": "Idiomas de traducción disponibles",
        "targetLanguagesHelp": "Seleccione a qué idiomas los usuarios pueden traducir en tiempo real"
      }
    },
    "radioStations": {
      "subtitle": "Administrar estaciones de radio",
      "emptyMessage": "No se encontraron estaciones de radio",
      "form": {
        "name": "Nombre de la estación",
        "genre": "Género",
        "streamUrl": "URL de transmisión",
        "currentShow": "Programa actual (opcional)",
        "currentSong": "Canción actual (opcional)",
        "order": "Orden"
      }
    },
    "podcasts": {
      "subtitle": "Administrar podcasts y episodios",
      "episodesSubtitle": "Administrar episodios",
      "emptyMessage": "No se encontraron podcasts",
      "noEpisodes": "No se encontraron episodios",
      "form": {
        "title": "Título del podcast",
        "author": "Autor",
        "description": "Descripción",
        "category": "Categoría",
        "rssFeed": "URL de feed RSS",
        "website": "URL del sitio web (opcional)"
      },
      "episodes": {
        "form": {
          "title": "Título del episodio",
          "description": "Descripción",
          "episodeNumber": "Número de episodio",
          "seasonNumber": "Número de temporada (opcional)",
          "duration": "Duración",
          "audioUrl": "URL de audio (requerido)",
          "publishedDate": "Fecha de publicación (YYYY-MM-DD)"
        }
      }
    },
    "users": {
      "subtitle": "Administrar usuarios y cuentas",
      "addUser": "Agregar Usuario",
      "status": {
        "active": "Activo",
        "inactive": "Inactivo",
        "blocked": "Bloqueado"
      },
      "filters": {
        "all": "Todos",
        "active": "Activos",
        "inactive": "Inactivos",
        "blocked": "Bloqueados"
      },
      "columns": {
        "name": "Nombre",
        "role": "Rol",
        "subscription": "Suscripción",
        "noSubscription": "Sin Suscripción",
        "status": "Estado",
        "created": "Creado",
        "actions": "Acciones"
      },
      "confirmDelete": "Eliminar Usuario",
      "confirmDeleteMessage": "¿Estás seguro de que quieres eliminar a {{name}}? Esta acción no se puede deshacer.",
      "resetPassword": "Restablecer Contraseña",
      "block": "Bloquear",
      "unban": "Desbloquear",
      "confirmResetPassword": "¿Enviar correo de restablecimiento de contraseña a {{email}}?",
      "resetPasswordSent": "Correo de restablecimiento enviado",
      "recentActivity": "Actividad Reciente",
      "noActivity": "Sin actividad",
      "notFound": "Usuario no encontrado",
      "backToList": "Volver a la lista",
      "banReason": "Motivo del bloqueo",
      "banReasonPrompt": "Motivo del bloqueo:",
      "confirmUnban": "¿Desbloquear usuario?",
      "userDetails": "Detalles del Usuario",
      "id": "ID",
      "registered": "Registrado",
      "billingHistory": "Historial de Facturación",
      "noPayments": "Sin pagos"
    },
    "campaigns": {
      "subtitle": "Administrar códigos de cupón y descuentos",
      "expired": "Expirado",
      "status": {
        "active": "Activo",
        "inactive": "Inactivo"
      },
      "columns": {
        "name": "Nombre",
        "discount": "Descuento",
        "usage": "Usos",
        "validUntil": "Válido Hasta",
        "status": "Estado",
        "actions": "Acciones"
      },
      "confirmDelete": "Eliminar Campaña",
      "confirmDeleteMessage": "¿Estás seguro de que quieres eliminar \"{{name}}\"? Esta acción no se puede deshacer.",
      "searchPlaceholder": "Buscar campañas...",
      "emptyMessage": "No se encontraron campañas",
      "deactivate": "Desactivar",
      "activate": "Activar",
      "createTitle": "Nueva Campaña",
      "editTitle": "Editar Campaña",
      "formSubtitle": "Configurar un código de cupón o descuento",
      "form": {
        "name": "Nombre de Campaña",
        "namePlaceholder": "ej. Venta de Verano 2024",
        "code": "Código de Cupón",
        "generate": "Generar",
        "discountType": "Tipo de Descuento",
        "discountValue": "Valor del Descuento",
        "maxUses": "Usos Máximos",
        "unlimited": "Ilimitado",
        "validUntil": "Válido Hasta",
        "active": "Campaña Activa"
      }
    },
    "subscriptions": {
      "subtitle": "Ver y administrar suscriptores del sistema",
      "status": {
        "active": "Activo",
        "paused": "Pausado",
        "cancelled": "Cancelado",
        "expired": "Expirado"
      },
      "columns": {
        "user": "Usuario",
        "plan": "Plan",
        "price": "Precio",
        "nextBilling": "Próxima Facturación",
        "status": "Estado"
      },
      "perMonth": "/mes",
      "searchPlaceholder": "Buscar suscripción...",
      "emptyMessage": "No se encontraron suscripciones",
      "actions": {
        "changePlan": "Cambiar plan",
        "pause": "Pausar",
        "resume": "Reanudar",
        "cancel": "Cancelar",
        "delete": "Eliminar"
      },
      "editPlan": {
        "title": "Cambiar Plan de Suscripción",
        "user": "Usuario",
        "currentPlan": "Plan Actual",
        "newPlan": "Seleccionar Nuevo Plan"
      },
      "addSubscription": {
        "title": "Agregar Suscripción",
        "userEmail": "Correo del Usuario",
        "emailPlaceholder": "Ingrese correo del usuario",
        "duration": "Duración (días)",
        "selectPlan": "Seleccionar Plan"
      },
      "fillAllFields": "Por favor complete todos los campos",
      "userNotFound": "Usuario no encontrado",
      "selectOneToEdit": "Por favor seleccione exactamente una suscripción para editar",
      "selectToDelete": "Por favor seleccione suscripciones para eliminar",
      "confirmDeleteMultiple": "¿Eliminar {{count}} suscripción(es)?",
      "selected": "seleccionados",
      "confirmDelete": "¿Está seguro de que desea eliminar la suscripción de {{user}}? Esta acción no se puede deshacer."
    },
    "marketingDashboard": {
      "subtitle": "Resumen de Marketing",
      "refresh": "Actualizar",
      "totalSubscribers": "Total de Suscriptores",
      "emailOpenRate": "Tasa de Apertura de Correo",
      "pushClickRate": "Tasa de Clic en Push",
      "activeSegments": "Segmentos Activos",
      "campaignStatus": {
        "active": "Activo",
        "completed": "Completado",
        "scheduled": "Programado",
        "draft": "Borrador"
      }
    },
    "transactions": {
      "subtitle": "Ver historial de pagos",
      "exportCsv": "Exportar CSV",
      "status": {
        "completed": "Completado",
        "pending": "Pendiente",
        "failed": "Fallido",
        "refunded": "Reembolsado"
      },
      "columns": {
        "id": "ID",
        "user": "Usuario",
        "amount": "Monto",
        "type": "Tipo",
        "status": "Estado",
        "date": "Fecha"
      },
      "filters": {
        "all": "Todos"
      },
      "searchPlaceholder": "Buscar transacción...",
      "emptyMessage": "No se encontraron transacciones",
      "details": "Detalles de Transacción",
      "email": "Correo"
    },
    "pushNotifications": {
      "subtitle": "Crear y enviar notificaciones a usuarios",
      "newNotification": "Nueva Notificación",
      "status": {
        "draft": "Borrador",
        "sent": "Enviado",
        "scheduled": "Programado"
      },
      "columns": {
        "title": "Título",
        "status": "Estado",
        "sent": "Enviados",
        "opened": "Abiertos",
        "scheduledAt": "Programado Para",
        "created": "Creado",
        "actions": "Acciones"
      },
      "filters": {
        "all": "Todos"
      },
      "searchPlaceholder": "Buscar notificación...",
      "emptyMessage": "No se encontraron notificaciones",
      "createModal": "Nueva Notificación Push",
      "editModal": "Editar Notificación",
      "scheduleModal": "Programar Notificación",
      "titleLabel": "Título",
      "bodyLabel": "Cuerpo",
      "dateTimeLabel": "Fecha y Hora",
      "cancel": "Cancelar",
      "create": "Crear Notificación",
      "schedule": "Programar",
      "send": "Enviar Ahora",
      "confirmSend": "¿Enviar notificación \"{{title}}\"?",
      "confirmDelete": "¿Eliminar notificación \"{{title}}\"?",
      "fillRequired": "Por favor completa título y cuerpo"
    }
  },
  "placeholder": {
    "email": "your@email.com",
    "password": "••••••••",
    "pin": "••••",
    "dateRange": {
      "from": "Desde (YYYY-MM-DD)",
      "to": "Hasta (YYYY-MM-DD)"
    },
    "amount": {
      "min": "Mín",
      "max": "Máx",
      "price": "0.00"
    },
    "chatMessage": "Escribe aquí...",
    "deepLink": "bayitplus://content/123",
    "scheduleDateTime": "YYYY-MM-DDTHH:mm",
    "roomCode": "ABCD1234",
    "time": {
      "start": "08:00",
      "end": "10:00"
    },
    "filter": {
      "userId": "Ingrese ID de usuario"
    },
    "datetime": "YYYY-MM-DDTHH:mm",
    "number": "0",
    "chat": "Escribe tu mensaje..."
  },
  "components": {
    "select": {
      "default": "Seleccionar..."
    }
  },
  "plans": {
    "basic": {
      "name": "Básico",
      "features": [
        "Todo el contenido VOD",
        "Radio y Podcasts",
        "Ver en 1 dispositivo",
        "Calidad SD"
      ],
      "notIncluded": [
        "Canales en vivo",
        "Asistente AI",
        "Ver sin conexión"
      ]
    },
    "premium": {
      "name": "Premium",
      "features": [
        "Todo el contenido VOD",
        "Canales en vivo",
        "Radio y Podcasts",
        "Asistente AI inteligente",
        "Ver en 2 dispositivos",
        "Calidad HD"
      ],
      "notIncluded": [
        "Ver sin conexión",
        "Perfiles familiares"
      ]
    },
    "family": {
      "name": "Familiar",
      "features": [
        "Todo el contenido VOD",
        "Canales en vivo",
        "Radio y Podcasts",
        "Asistente AI inteligente",
        "Ver en 4 dispositivos",
        "Calidad 4K",
        "5 perfiles familiares",
        "Descargar sin conexión"
      ],
      "notIncluded": []
    },
    "batchActions": {
      "selectedCount": "{{count}} seleccionados",
      "selectedCount_one": "{{count}} seleccionado",
      "selectedCount_other": "{{count}} seleccionados",
      "clear": "Limpiar"
    },
    "costDashboard": {
      "title": "Panel de Costos",
      "costBreakdown": "Desglose de Costos",
      "loadingBreakdown": "Cargando desglose...",
      "aiCosts": "Costos de IA",
      "infrastructure": "Infraestructura",
      "thirdParty": "Terceros",
      "thirdPartyApis": "APIs de Terceros",
      "translation": "Traducción",
      "search": "Búsqueda",
      "percentOfTotal": "% del total",
      "components": "Componentes",
      "topSpenders": {
        "title": "Top 20 Usuarios (Mensual)",
        "loading": "Cargando usuarios principales...",
        "rank": "Rango",
        "userId": "ID de Usuario",
        "costRange": "Rango de Costos",
        "privacyNote": "Los IDs de usuario están encriptados y los costos se muestran en rangos para proteger la privacidad."
      },
      "categories": {
        "permanent": "Permanente",
        "transient": "Variable",
        "permanentVsTransient": "Permanente vs Variable",
        "permanentFixed": "Permanente (Fijo)",
        "transientVariable": "Variable (Uso)",
        "permanentDesc": "Costos de infraestructura que ocurren mensualmente sin importar el uso",
        "transientDesc": "Costos basados en uso que fluctúan con la actividad de la plataforma",
        "detailedBreakdown": "Desglose Detallado",
        "costItem": "Elemento de Costo",
        "category": "Categoría",
        "amount": "Monto"
      },
      "timeline": {
        "title": "Línea de Tiempo de Costos",
        "loading": "Cargando línea de tiempo...",
        "amountLabel": "Monto ($)",
        "revenue": "Ingresos",
        "totalCost": "Costo Total",
        "netProfit": "Ganancia Neta",
        "showingData": "Mostrando datos de {{start}} a {{end}}"
      },
      "plSummary": {
        "netProfitLoss": "Ganancia/Pérdida Neta",
        "margin": "margen",
        "revenue": "INGRESOS",
        "totalCosts": "COSTOS TOTALES"
      }
    }
  },
  "subscribe": {
    "title": "Elige tu plan",
    "subtitle": "7 días de prueba gratis para cualquier plan. Cancela en cualquier momento.",
    "monthly": "Mensual",
    "yearly": "Anual",
    "save2Months": "Ahorra 2 meses",
    "popular": "Más Popular",
    "period": "/mes",
    "perYear": "/año",
    "select": "Seleccionar plan",
    "selected": "Seleccionado",
    "processing": "Procesando...",
    "startTrial": "Comenzar Prueba Gratis",
    "noCharge": "Tu tarjeta de crédito no será cobrada durante el período de prueba"
  },
  "notFound": {
    "title": "Página no encontrada",
    "description": "La página que buscas no existe o se ha movido.",
    "homeButton": "Ir al inicio",
    "searchButton": "Buscar",
    "orTry": "O intenta:",
    "liveChannel": "En vivo",
    "vodLabel": "Películas",
    "podcastsLabel": "Podcasts"
  },
  "profiles": {
    "addProfile": "Añadir perfil",
    "enterPin": "Ingresa PIN",
    "selectError": "Error al seleccionar perfil",
    "wrongPin": "PIN incorrecto",
    "loading": "Cargando perfiles...",
    "manage": "Administrar perfiles",
    "whoIsWatching": "¿Quién está viendo?",
    "manageProfiles": "Administrar perfiles",
    "kids": "Ninos",
    "addIcon": "+"
  },
  "watch": {
    "notFound": "Contenido no encontrado",
    "backToHome": "Volver al inicio",
    "episodes": "Episodios",
    "addToList": "Añadir a lista",
    "like": "Me gusta",
    "share": "Compartir",
    "cast": "Elenco",
    "episodesList": "Episodios",
    "schedule": "Horario",
    "now": "Ahora",
    "related": "Contenido relacionado",
    "deleteEpisode": "Eliminar Episodio",
    "confirmDeleteEpisode": "¿Eliminar este episodio?"
  },
  "live": {
    "title": "Televisión en Vivo",
    "next": "Siguiente:",
    "noChannels": "Sin canales disponibles",
    "tryLater": "Intenta de nuevo más tarde",
    "categories": {
      "all": "Todos",
      "news": "Noticias",
      "entertainment": "Entretenimiento",
      "sports": "Deportes",
      "kids": "Niños",
      "music": "Música"
    }
  },
  "judaism": {
    "title": "Judaísmo",
    "items": "elementos",
    "empty": "Sin contenido disponible",
    "emptyHint": "Intenta seleccionar otra categoría",
    "dashboard": "Tu Panel Judío",
    "categories": {
      "news": "Noticias Judías",
      "community": "Comunidad"
    },
    "shabbat": {
      "title": "Horarios de Shabat",
      "shabbatShalom": "¡Shabat Shalom!",
      "shabbatMode": "Modo Shabat",
      "endsIn": "Shabat termina en",
      "candleLighting": "Encendido de velas",
      "havdalah": "Havdalá",
      "parashat": "Parashat",
      "friday": "Viernes",
      "saturday": "Sábado",
      "noData": "No se pueden cargar los horarios de Shabat"
    },
    "erevShabbat": {
      "title": "Víspera de Shabat",
      "prepareFor": "Prepárate para Shabat",
      "inTime": "en {{time}}",
      "featuredContent": "Contenido de Shabat",
      "noContent": "¡Contenido de Shabat próximamente!",
      "shabbatShalom": "¡Shabat Shalom!",
      "timeUntil": "Tiempo hasta Shabat",
      "shabbatSongs": "Canciones de Shabat",
      "parashaStudy": "Parashá",
      "shabbatRecipes": "Recetas",
      "prayers": "Oraciones"
    }
  },
  "children": {
    "title": "Niños",
    "items": "elementos",
    "empty": "Sin contenido disponible",
    "emptyHint": "Prueba otra categoría",
    "exitKidsMode": "Salir del modo niños",
    "exitDescription": "Ingresa el código de padre para salir",
    "parentCode": "Código de padre",
    "confirm": "Confirmar",
    "wrongCode": "Código incorrecto",
    "noContent": "Sin contenido disponible",
    "tryAnotherCategory": "Intenta seleccionar otra categoría",
    "categories": {
      "all": "Todo",
      "cartoons": "Dibujos animados",
      "educational": "Educativo",
      "music": "Música",
      "hebrew": "Hebreo",
      "stories": "Historias",
      "jewish": "Judío"
    },
    "ageRatings": {
      "3": "Edades 3+",
      "5": "Edades 5+",
      "7": "Edades 7+",
      "10": "Edades 10+",
      "12": "Edades 12+"
    },
    "moderation": {
      "pending": "Pendiente de revisión",
      "approved": "Aprobado",
      "rejected": "Rechazado"
    },
    "admin": {
      "stats": "Administrador de contenido infantil",
      "seedContent": "Sembrar contenido",
      "importArchive": "Importar de Archive.org",
      "syncPodcasts": "Sincronizar podcasts",
      "syncYouTube": "Sincronizar YouTube",
      "tagVod": "Etiquetar VOD",
      "pendingModeration": "Pendiente de moderación"
    }
  },
  "youngsters": {
    "title": "Jóvenes",
    "items": "elementos",
    "empty": "Sin contenido disponible",
    "emptyHint": "Prueba otra categoría",
    "exitYoungstersMode": "Salir del modo jóvenes",
    "exitDescription": "Ingresa el código de padre para salir",
    "parentCode": "Código de padre",
    "confirm": "Confirmar",
    "wrongCode": "Código incorrecto",
    "noContent": "Sin contenido disponible",
    "tryAnotherCategory": "Intenta seleccionar otra categoría",
    "categories": {
      "all": "Todo",
      "trending": "Tendencias",
      "news": "Noticias",
      "culture": "Cultura",
      "educational": "Educativo",
      "music": "Música",
      "entertainment": "Entretenimiento",
      "sports": "Deportes",
      "tech": "Tecnología",
      "judaism": "Judaísmo"
    },
    "ageGroups": {
      "middle-school": "Escuela Secundaria (12-14)",
      "high-school": "Preparatoria (15-17)"
    },
    "moderation": {
      "pending": "Pendiente de revisión",
      "approved": "Aprobado",
      "rejected": "Rechazado"
    },
    "admin": {
      "stats": "Administrador de contenido para jóvenes",
      "seedContent": "Sembrar contenido",
      "importArchive": "Importar de Archive.org",
      "syncPodcasts": "Sincronizar podcasts",
      "syncYouTube": "Sincronizar YouTube",
      "tagVod": "Etiquetar VOD",
      "pendingModeration": "Pendiente de moderación"
    }
  },
  "chatbot": {
    "title": "Asistente Bayit+",
    "greeting": "Hola! Soy el asistente inteligente de Bayit+. ¿Cómo puedo ayudarte hoy? Haz clic en el micrófono y habla, o escribe un mensaje.",
    "openChat": "Abrir chat",
    "welcome": "¡Hola! Soy el asistente inteligente de Bayit+. ¿Cómo puedo ayudarte hoy? Haz clic en el micrófono y habla, o escribe un mensaje.",
    "placeholder": "Escribe aquí...",
    "recording": "Grabando... haz clic de nuevo para detener",
    "transcribing": "Transcribiendo...",
    "stopRecording": "Detener grabación",
    "startRecording": "Iniciar grabación de voz",
    "recommendations": "Aquí tienes algunas recomendaciones:",
    "showMultipleSuccess": "Mostrando {{count}} elementos de contenido en widgets",
    "showMultipleNotFound": "No se pudo encontrar el contenido solicitado. Intente con otros nombres.",
    "resolvingContent": "Buscando tu contenido...",
    "errors": {
      "micPermission": "No se pudo acceder al micrófono. Por favor, verifica los permisos del micrófono en tu navegador.",
      "transcribeFailed": "No se pudo transcribir la grabación. Por favor, inténtalo de nuevo.",
      "general": "Lo siento, algo salió mal. Por favor, inténtalo de nuevo."
    },
    "suggestions": {
      "whatToWatch": "¿Qué ver hoy?",
      "israeliMovies": "Películas israelíes recomendadas",
      "whatsOnNow": "¿Qué hay ahora?",
      "popularPodcasts": "Podcasts populares"
    },
    "voiceCommands": {
      "showChannels": "Muéstrame canales...",
      "playChess": "Iniciar un juego de ajedrez con...",
      "multiContent": "Mostrar lado a lado..."
    }
  },
  "chat": {
    "title": "Asistente Bayit+",
    "greeting": "Hola! Soy el asistente inteligente de Bayit+. ¿Cómo puedo ayudarte hoy? Haz clic en el micrófono y habla, o escribe un mensaje."
  },
  "subtitles": {
    "nikud": "Nikud",
    "selection": "Selección",
    "translation": "Traducción",
    "translating": "Traduciendo...",
    "close": "Cerrar",
    "unavailable": "Traducción no disponible",
    "off": "Desactivado",
    "none": "Ninguno",
    "autoGenerated": "Generados automáticamente",
    "selectLanguage": "Seleccionar Idioma de Subtítulos",
    "liveTranslate": "Traducción en Vivo",
    "translateTo": "Traducir a",
    "downloadMore": "Descargar más subtítulos...",
    "downloading": "Buscando en OpenSubtitles...",
    "opensubtitlesSource": "De OpenSubtitles.com",
    "downloadSuccess": "Se descargaron {{count}} subtítulo(s)",
    "noSubtitlesFound": "No se encontraron subtítulos para este contenido",
    "smartSubs": "Subtítulos Inteligentes",
    "smartSubsDescription": "Vista dual: Hebreo simplificado + Inglés con resaltado de raíces",
    "smartSubsDualView": "Vista Dual",
    "shoreshToggle": "Resaltado de Raíces",
    "shoreshOn": "Resaltado de Shoresh activado",
    "shoreshOff": "Resaltado de Shoresh desactivado",
    "nikudLive": "Hebreo con Nikud",
    "nikudLiveDescription": "Subtítulos en hebreo vocalizados con marcas diacríticas para lectura más fácil",
    "nikudEnabled": "Subtítulos Nikud activados",
    "nikudDisabled": "Subtítulos Nikud desactivados",
    "nikudSubtitleLabel": "Hebreo con nikud: {{text}}",
    "available": "Subtítulos",
    "clickToEnable": "Haz clic para activar la traducción en vivo",
    "connectionError": "Error de Traducción en Vivo",
    "inputLanguageTooltip": "Verificar Idioma de Entrada",
    "premiumRequired": "Se requiere suscripción Premium",
    "selectInputLanguage": "Seleccionar idioma de entrada",
    "translateActive": "Traducción en Vivo Activa",
    "noEnglishSubtitles": "No hay subtítulos en inglés disponibles para este contenido.",
    "hebrewMode": {
      "title": "Modo de Visualización en Hebreo",
      "unavailable": "No disponible",
      "generate": "Generar",
      "regular": {
        "title": "Hebreo Regular",
        "description": "Texto hebreo estándar sin marcas vocálicas"
      },
      "nikud": {
        "title": "Hebreo con Nikud",
        "description": "Hebreo vocalizado con marcas vocálicas para lectura más fácil",
        "unavailableReason": "El procesamiento de IA no está disponible para este contenido"
      },
      "shoresh": {
        "title": "Shoresh (Palabras Raíz)",
        "description": "Palabras hebreas con análisis de raíz: palabra [raíz]",
        "unavailableReason": "El análisis de palabras raíz no está disponible para este contenido"
      }
    },
    "englishMode": {
      "title": "Modo de Visualización en Inglés",
      "unavailable": "No disponible",
      "generate": "Generar",
      "firstTimeHint": "Estos modos impulsados por IA ayudan a mantener el hebreo mientras aprendes la estructura de oraciones en inglés. Cada modo ofrece una experiencia de aprendizaje única.",
      "regular": {
        "title": "Inglés Regular",
        "description": "Subtítulos estándar en inglés"
      },
      "heblish": {
        "title": "Heblish",
        "description": "Inglés con inyecciones de palabras en hebreo para aprendizaje inmersivo",
        "unavailableReason": "El procesamiento de Heblish no está disponible para este contenido"
      },
      "grammarFlip": {
        "title": "Grammar-Flip",
        "description": "Palabras hebreas con estructura de oraciones en inglés (Sujeto-Verbo-Objeto)",
        "unavailableReason": "El procesamiento Grammar-Flip no está disponible para este contenido"
      },
      "slangSynthesis": {
        "title": "Síntesis de jerga",
        "description": "Mezcla de jerga israelí y americana moderna para contenido atractivo",
        "unavailableReason": "El procesamiento Slang Synthesis no está disponible para este contenido"
      }
    },
    "loading": "Cargando subtítulos...",
    "error": {
      "title": "Error de Subtítulos",
      "retry": "Intentar de Nuevo",
      "loadFailed": "Error al cargar subtítulos",
      "cuesFailed": "Error al cargar texto de subtítulos",
      "networkError": "Error de red - por favor verifica tu conexión",
      "serverError": "Error del servidor - por favor intenta más tarde"
    },
    "aiModesAvailable": "Modos de IA disponibles",
    "aiModesTitle": "Modos de subtitulos IA",
    "fetchSubtitles": "Obtener subtitulos",
    "fontSize": "Tamano de fuente",
    "mode": {
      "engrew": "Engrew",
      "heblish": "Heblish",
      "shoresh": "Shoresh",
      "standard": "Estandar"
    },
    "opensubtitles": "OpenSubtitles",
    "searchExternal": "Buscar subtitulos externos",
    "settingsTitle": "Configuracion de subtitulos",
    "showBackground": "Mostrar fondo",
    "singleMode": "Modo unico",
    "splitMode": "Modo dividido",
    "primary_language": "Idioma Principal",
    "secondary_language": "Idioma Secundario",
    "layout_mode": "Modo de diseño",
    "interactive_title": "Subtítulos Interactivos"
  },
  "video": {
    "watchTrailer": "Ver Tráiler",
    "closeTrailer": "Cerrar Tráiler",
    "deleteConfirm": "¿Eliminar este episodio?"
  },
  "recordings": {
    "title": "Mis Grabaciones",
    "subtitle": "Ver y administrar tus transmisiones en vivo grabadas",
    "record": "Grabar",
    "recording": "Grabando",
    "storageUsed": "Almacenamiento Usado",
    "totalRecordings": "Total de Grabaciones",
    "maxDuration": "Duración Máxima",
    "noRecordings": "No Hay Grabaciones Aún",
    "noRecordingsHint": "¡Comienza a grabar desde cualquier canal en vivo!",
    "confirmDelete": "¿Estás seguro de que deseas eliminar esta grabación? Esta acción no se puede deshacer.",
    "deleteRecording": "Eliminar Grabación",
    "deleteFailed": "Error al eliminar la grabación",
    "expires": "Expira",
    "subtitlesAvailable": "Subtítulos Disponibles",
    "recordingSaved": "¡Grabación Guardada!",
    "savedSuccess": "Grabación guardada exitosamente! Duración: {{duration}}",
    "viewInMyRecordings": "Ver en Mis Grabaciones",
    "error": "Error de Grabación",
    "startFailed": "Error al iniciar la grabación. Por favor, inténtalo de nuevo.",
    "stopFailed": "Error al detener la grabación. Por favor, inténtalo de nuevo.",
    "page": "Página"
  },
  "chess": {
    "title": "Ajedrez",
    "welcome": "Bienvenido al Ajedrez",
    "subtitle": "Juega ajedrez con amigos y familiares alrededor del mundo",
    "createGame": "Crear Nuevo Juego",
    "joinGame": "Unirse al Juego",
    "gameCode": "Código del Juego",
    "enterGameCode": "Ingresa el Código del Juego",
    "invalidGameCode": "Código de juego inválido. Debe tener 6 caracteres.",
    "joinFailed": "Error al unirse al juego",
    "join": "Unirse",
    "create": "Crear",
    "chooseColor": "Elige Tu Color",
    "white": "Blanco",
    "black": "Negro",
    "chatPlaceholder": "Escribe un mensaje... (@bot para consejos)",
    "botHint": "Etiqueta @bot en tu mensaje para obtener consejos de ajedrez de nuestro asistente AI",
    "bot": "Asistente de Ajedrez",
    "mute": "Silenciar",
    "unmute": "Activar Sonido",
    "speaking": "participantes",
    "resign": "Rendirse",
    "offerDraw": "Ofrecer Empate",
    "newGame": "Nuevo Juego",
    "checkmate": "¡Jaque Mate!",
    "stalemate": "Tablas por Ahogado",
    "draw": "Empate",
    "resigned": "Juego Abandonado",
    "reconnecting": "Reconectando...",
    "moveHistory": "Historial de Movimientos",
    "noMoves": "No hay movimientos aún",
    "showHints": "Mostrar pistas de guía",
    "yourTurn": "Tu Turno",
    "opponentTurn": "Turno del Oponente",
    "waitingForOpponent": "Esperando al oponente...",
    "gameOver": "Juego Terminado",
    "sendingInvite": "Enviando invitación de juego a {{name}}...",
    "inviteSent": "Invitación de juego enviada a {{name}}. Código: {{code}}",
    "inviteFailed": "No se pudo encontrar ese usuario. Verifica el nombre e inténtalo de nuevo.",
    "inviteReceived": "¡{{name}} te ha invitado a una partida de ajedrez!",
    "joinInvite": "Unirse al juego",
    "challenge": "Desafiar",
    "playedAsWhite": "Jugó con blancas",
    "playedAsBlack": "Jugó con negras",
    "gameMode": "Modo de juego",
    "playVsFriend": "Jugar contra amigo",
    "playVsBot": "Jugar contra bot",
    "difficulty": "Dificultad",
    "easy": "Fácil",
    "medium": "Medio",
    "hard": "Difícil",
    "chessBot": "Bot de ajedrez",
    "chat": {
      "title": "Chat",
      "inputPlaceholder": "Escribe un mensaje..."
    },
    "acceptDraw": "Aceptar empate",
    "acceptInvite": "Aceptar invitación",
    "blackCaptured": "Negro capturado",
    "blackTurn": "Turno del negro",
    "challengeFriend": "Desafiar amigo",
    "challengeViaWhatsApp": "Desafiar vía WhatsApp",
    "copyCode": "Copiar código",
    "declineDraw": "Rechazar empate",
    "declineInvite": "Rechazar invitación",
    "drawOffered": "Empate ofrecido",
    "joinByGameCode": "Unirse por código",
    "noFriendsYet": "Aún no hay amigos",
    "offline": "Sin conexión",
    "online": "En línea",
    "opponent": "Oponente",
    "whiteCaptured": "Blanco capturado",
    "whiteTurn": "Turno del blanco",
    "you": "You"
  },
  "friends": {
    "title": "Amigos y Oponentes",
    "subtitle": "Conecta con jugadores y desafía a amigos",
    "myFriends": "Mis Amigos",
    "requests": "Solicitudes",
    "findPlayers": "Buscar Jugadores",
    "friendsLabel": "Amigos",
    "pendingLabel": "Pendiente",
    "add": "Agregar Amigo",
    "remove": "Eliminar",
    "accept": "Aceptar",
    "reject": "Rechazar",
    "cancel": "Cancelar",
    "noFriends": "Aún no tienes amigos",
    "noFriendsDesc": "Busca jugadores y envía solicitudes de amistad",
    "lastGame": "Último juego: {{time}}",
    "friendsSince": "Amigos desde {{date}}",
    "incomingRequests": "Solicitudes Recibidas",
    "outgoingRequests": "Solicitudes Enviadas",
    "noIncoming": "No hay solicitudes recibidas",
    "noOutgoing": "No hay solicitudes enviadas",
    "sentAt": "Enviado {{time}}",
    "searchPlaceholder": "Buscar por nombre...",
    "noResults": "No se encontraron jugadores",
    "noResultsDesc": "Intenta buscar con un nombre diferente",
    "requestSent": "¡Solicitud de amistad enviada!",
    "requestAccepted": "¡Solicitud de amistad aceptada!",
    "requestRejected": "Solicitud de amistad rechazada",
    "requestCancelled": "Solicitud de amistad cancelada",
    "friendRemoved": "Amigo eliminado",
    "searchFailed": "Error al buscar usuarios",
    "requestFailed": "Error al enviar solicitud",
    "acceptFailed": "Error al aceptar solicitud",
    "rejectFailed": "Error al rechazar solicitud",
    "cancelFailed": "Error al cancelar solicitud",
    "removeFailed": "Error al eliminar amigo",
    "friendsCount": "{{count}} amigos",
    "gamesCount": "{{count}} juegos",
    "alreadyFriends": "Amigos"
  },
  "stats": {
    "statistics": "Estadísticas",
    "matchHistory": "Historial de Partidas",
    "headToHead": "Cara a Cara",
    "gamesPlayed": "Partidas Jugadas",
    "wins": "Victorias",
    "losses": "Derrotas",
    "draws": "Empates",
    "winRate": "Tasa de Victoria",
    "rating": "Clasificación",
    "peakRating": "Clasificación Máxima",
    "peak": "Máximo",
    "winStreak": "Racha de Victorias",
    "currentStreak": "Racha Actual",
    "bestStreak": "Mejor Racha",
    "performance": "Rendimiento",
    "achievements": "Logros",
    "currentRating": "Clasificación Actual",
    "totalGames": "Total de Partidas",
    "noGames": "Aún no hay juegos jugados",
    "moves": "movimientos",
    "won": "Ganó",
    "lost": "Perdió",
    "draw": "Empate",
    "overall": "Récord General",
    "yourWins": "Tus Victorias",
    "theirWins": "Sus Victorias",
    "totalGamesPlayed": "Total: {{count}} partidas",
    "recentGames": "Juegos Recientes"
  },
  "support": {
    "title": "Centro de Soporte",
    "subtitle": "¿Cómo podemos ayudarte hoy?",
    "tabs": {
      "docs": "Documentación",
      "faq": "Preguntas Frecuentes",
      "contact": "Contacto",
      "tickets": "Mis Tickets"
    },
    "categories": {
      "title": "Explorar Documentación",
      "loading": "Cargando documentación...",
      "loadError": "Error al cargar categorías",
      "articleCount": "{{count}} artículos",
      "gettingStarted": "Comenzar",
      "features": "Funciones",
      "troubleshooting": "Solución de Problemas",
      "account": "Cuenta"
    },
    "docs": {
      "loading": "Cargando documento...",
      "loadError": "Error al cargar documento",
      "backToList": "Volver a documentación"
    },
    "search": {
      "placeholder": "Buscar en documentación...",
      "noResults": "No se encontraron resultados"
    },
    "faq": {
      "title": "Preguntas Frecuentes",
      "loading": "Cargando preguntas frecuentes...",
      "loadError": "Error al cargar FAQ",
      "empty": "No hay elementos en esta categoría",
      "categories": {
        "all": "Todos los Temas",
        "general": "General",
        "billing": "Facturación",
        "technical": "Técnico",
        "features": "Funciones"
      }
    },
    "contact": {
      "voiceTitle": "Soporte por Voz",
      "voiceDescription": "Haz clic en el botón del avatar o di \"Jarvis\" para iniciar una conversación con nuestro asistente.",
      "ticketTitle": "Crear Ticket de Soporte",
      "ticketDescription": "¿Necesitas asistencia humana? Crea un ticket y nuestro equipo responderá en 24 horas.",
      "createTicket": "Crear Ticket",
      "emailTitle": "Soporte por Email",
      "emailDescription": "¿Prefieres email? Contáctanos en support@bayit.tv para cualquier consulta."
    },
    "ticket": {
      "title": "Crear Ticket de Soporte",
      "subject": "Asunto",
      "subjectPlaceholder": "Breve descripción del problema",
      "message": "Mensaje",
      "messagePlaceholder": "Describe tu problema en detalle...",
      "categoryLabel": "Categoría",
      "priorityLabel": "Prioridad",
      "submit": "Enviar Ticket",
      "category": {
        "billing": "Facturación",
        "technical": "Técnico",
        "feature": "Solicitud de Función",
        "general": "General"
      },
      "priority": {
        "low": "Baja",
        "medium": "Media",
        "high": "Alta",
        "urgent": "Urgente"
      },
      "status": {
        "open": "Abierto",
        "in_progress": "En Progreso",
        "resolved": "Resuelto",
        "closed": "Cerrado"
      },
      "created": "Creado",
      "error": {
        "required": "Por favor completa todos los campos requeridos",
        "submit": "Error al crear ticket. Intenta de nuevo."
      }
    },
    "tickets": {
      "title": "Mis Tickets de Soporte",
      "loading": "Cargando tickets...",
      "loadError": "Error al cargar tickets",
      "empty": "No tienes tickets aún",
      "emptyFilter": "No hay tickets con este estado",
      "create": "Nuevo Ticket",
      "createFirst": "Crea Tu Primer Ticket",
      "filter": {
        "all": "Todos",
        "open": "Abierto",
        "inProgress": "En Progreso",
        "resolved": "Resuelto"
      }
    },
    "voice": {
      "title": "Asistente de Voz",
      "listening": "Estoy escuchando...",
      "thinking": "Déjame pensar en eso...",
      "speaking": "Hablando...",
      "error": "Lo siento, no entendí. ¿Puedes repetir?",
      "ready": "¿Qué te gustaría saber?",
      "listeningNow": "Escuchando...",
      "wakeWordHint": "Di \"Jarvis\" para hablar"
    },
    "wizard": {
      "role": "Tu Guía"
    }
  },
  "jerusalem": {
    "title": "Conexión con Jerusalén",
    "subtitle": "Mantente conectado al corazón de Israel",
    "noContent": "No hay contenido de Jerusalén disponible",
    "sources": "Fuentes",
    "kotelLive": "Muro Occidental en Vivo",
    "categories": {
      "kotel": "Muro Occidental",
      "idf-ceremony": "Ceremonias de las FDI",
      "diaspora-connection": "Conexión con la Diáspora",
      "holy-sites": "Sitios Sagrados",
      "jerusalem-events": "Eventos en Jerusalén",
      "general": "Jerusalén"
    }
  },
  "telAviv": {
    "title": "Conexión con Tel Aviv",
    "subtitle": "La ciudad que nunca duerme",
    "noContent": "No hay contenido de Tel Aviv disponible",
    "sources": "Fuentes",
    "beachLive": "Cámara de Playa",
    "categories": {
      "beaches": "Playas",
      "nightlife": "Vida Nocturna",
      "culture": "Cultura y Arte",
      "music": "Escena Musical",
      "food": "Gastronomía",
      "tech": "Tecnología",
      "events": "Eventos",
      "general": "Tel Aviv"
    }
  },
  "voiceOnboarding": {
    "welcome": {
      "title": "Bienvenido al control por voz",
      "description": "Controla Bayit+ con tu voz para una experiencia manos libres."
    },
    "features": {
      "voiceCommands": "Comandos de Voz",
      "voiceCommandsDesc": "Navega, busca y controla la reproducción con habla natural",
      "tts": "Texto a Voz",
      "ttsDesc": "Escucha las respuestas y descripciones de contenido en voz alta",
      "wakeWord": "Palabra de Activación",
      "wakeWordDesc": "Di 'Bayit' para activar el control por voz en cualquier momento"
    },
    "getStarted": "Comenzar",
    "permissions": {
      "title": "Acceso al Micrófono",
      "description": "El control por voz requiere acceso al micrófono para escuchar tus comandos",
      "privacy": "Tus datos de voz se procesan de forma segura y nunca se almacenan"
    },
    "permissionsGranted": "Acceso al micrófono concedido",
    "permissionRequired": {
      "title": "Permiso Requerido",
      "message": "Por favor, habilita el acceso al micrófono en la configuración de tu dispositivo para usar el control por voz"
    },
    "grantPermissions": "Conceder Permisos",
    "testWakeWord": {
      "title": "Probar Palabra de Activación",
      "description": "Di 'Bayit' para probar la activación por voz",
      "success": "¡Genial! La activación por voz está funcionando"
    },
    "startTest": "Iniciar Prueba",
    "complete": {
      "title": "¡Todo Listo!",
      "description": "El control por voz está habilitado. Prueba estos comandos:",
      "tryCommands": "Prueba Estos Comandos",
      "examples": {
        "search": "\"Buscar Fauda\"",
        "play": "\"Reproducir las noticias\"",
        "navigate": "\"Ir a TV en Vivo\"",
        "control": "\"Pausar\" o \"Subir volumen\""
      },
      "startUsing": "Comenzar a Usar Control por Voz"
    },
    "skip": "Omitir por ahora",
    "buttons": {
      "back": "Atras"
    },
    "completion": {
      "message": "Las funciones de voz estan listas.",
      "title": "Configuracion de voz completada"
    },
    "title": "Configuracion de voz",
    "training": {
      "message": "Lee las frases en voz alta para entrenar el reconocimiento.",
      "title": "Entrenamiento de voz"
    }
  },
  "taxonomy": {
    "sections": {
      "movies": "Películas",
      "series": "Series",
      "kids": "Niños",
      "youngsters": "Jóvenes",
      "music": "Música",
      "documentaries": "Documentales",
      "podcasts": "Podcasts",
      "live": "TV en vivo"
    },
    "subcategories": {
      "learning-hebrew": "Aprender Hebreo",
      "learning-hebrew.description": "Aprender a leer, escribir y vocabulario en hebreo para niños",
      "young-science": "Ciencia Joven",
      "young-science.description": "Experimentos y explicaciones científicas adaptadas para niños",
      "math-fun": "Matemáticas Divertidas",
      "math-fun.description": "Aprender números y aritmética de forma divertida y lúdica",
      "nature-animals": "Naturaleza y Animales",
      "nature-animals.description": "El mundo de los animales y la naturaleza para niños curiosos",
      "interactive": "Interactivo",
      "interactive.description": "Contenido interactivo y participativo para niños",
      "hebrew-songs": "Canciones en Hebreo",
      "hebrew-songs.description": "Canciones infantiles israelíes clásicas y nuevas",
      "nursery-rhymes": "Canciones de Cuna",
      "nursery-rhymes.description": "Canciones y melodías para niños pequeños y bebés",
      "kids-movies": "Películas para Niños",
      "kids-movies.description": "Películas completas adecuadas para niños",
      "kids-series": "Series para Niños",
      "kids-series.description": "Series animadas y programas de televisión para niños",
      "jewish-holidays": "Fiestas Judías",
      "jewish-holidays.description": "Contenido sobre festividades judías y tradiciones para niños",
      "torah-stories": "Historias de la Torá",
      "torah-stories.description": "Historias de la Torá y la tradición judía",
      "bedtime-stories": "Cuentos para Dormir",
      "bedtime-stories.description": "Historias relajantes para la hora de dormir",
      "tiktok-trends": "Tendencias TikTok",
      "tiktok-trends.description": "Tendencias calientes y desafíos en TikTok",
      "viral-videos": "Videos Virales",
      "viral-videos.description": "Videos virales populares en redes sociales",
      "memes": "Memes",
      "memes.description": "Memes divertidos y cultura de internet",
      "israel-news": "Noticias de Israel",
      "israel-news.description": "Noticias de Israel adaptadas para adolescentes",
      "world-news": "Noticias Mundiales",
      "world-news.description": "Noticias internacionales para jóvenes",
      "science-news": "Noticias de Ciencia",
      "science-news.description": "Descubrimientos científicos e innovación tecnológica",
      "sports-news": "Noticias Deportivas",
      "sports-news.description": "Actualizaciones deportivas y resultados de juegos",
      "music-culture": "Cultura Musical",
      "music-culture.description": "Escena musical, artistas y festivales",
      "film-culture": "Cultura Cinematográfica",
      "film-culture.description": "Cine, series y críticas",
      "art-culture": "Cultura Artística",
      "art-culture.description": "Arte, galerías y creatividad",
      "food-culture": "Cultura Gastronómica",
      "food-culture.description": "Cocina, recetas y cultura alimentaria",
      "study-help": "Ayuda de Estudio",
      "study-help.description": "Ayuda con exámenes, resúmenes y preparación para pruebas",
      "career-prep": "Preparación Profesional",
      "career-prep.description": "Preparación universitaria y profesional",
      "life-skills": "Habilidades de Vida",
      "life-skills.description": "Habilidades para la vida, gestión de dinero e independencia",
      "teen-movies": "Películas para Adolescentes",
      "teen-movies.description": "Películas recomendadas para adolescentes",
      "teen-series": "Series para Adolescentes",
      "teen-series.description": "Series populares para adolescentes",
      "gaming": "Videojuegos",
      "gaming.description": "Videojuegos, e-sports y gaming",
      "coding": "Programación",
      "coding.description": "Programación, codificación y desarrollo de software",
      "gadgets": "Tecnología",
      "gadgets.description": "Gadgets, tecnología y reseñas",
      "bar-bat-mitzvah": "Bar/Bat Mitzvá",
      "bar-bat-mitzvah.description": "Preparación y celebraciones de Bar/Bat Mitzvá",
      "teen-torah": "Torá para Jóvenes",
      "teen-torah.description": "Clases de Torá y porción semanal para adolescentes",
      "jewish-history": "Historia Judía",
      "jewish-history.description": "Historia del pueblo judío"
    }
  },
  "passkey": {
    "manager": {
      "title": "Claves de Acceso",
      "subtitle": "Gestiona tus claves de acceso para contenido seguro"
    },
    "unsupported": "Las claves de acceso no son compatibles con este dispositivo",
    "fetchError": "Error al cargar las claves de acceso",
    "registerError": "Error al registrar la clave de acceso",
    "deleteError": "Error al eliminar la clave de acceso",
    "cancelled": "La operación de clave de acceso fue cancelada",
    "noPasskeys": "Aún no hay claves de acceso registradas. Agrega una para desbloquear contenido privado.",
    "unknownDevice": "Dispositivo Desconocido",
    "created": "Creada",
    "lastUsed": "Último uso",
    "never": "Nunca",
    "addPasskey": "Agregar Clave de Acceso",
    "deleteConfirmTitle": "¿Eliminar Clave de Acceso?",
    "deleteConfirmText": "Esta clave de acceso ya no podrá desbloquear contenido. Siempre puedes agregarla de nuevo más tarde.",
    "unlock": "Desbloquear",
    "unlockContent": "Desbloquear Contenido Privado",
    "unlockDescription": "Usa tu clave de acceso para acceder a películas y series privadas",
    "auth": {
      "title": "Desbloquear Contenido",
      "description": "Usa tu huella digital, rostro o PIN del dispositivo para desbloquear películas y series privadas.",
      "unlock": "Desbloquear con Clave de Acceso",
      "authenticating": "Autenticando...",
      "success": "¡Contenido Desbloqueado!",
      "cancelled": "La autenticación fue cancelada",
      "error": "La autenticación falló. Por favor, intenta de nuevo."
    },
    "qr": {
      "useQR": "Usar Teléfono para Desbloquear",
      "scanWithPhone": "Escanea con tu teléfono",
      "instruction": "Abre la cámara en tu teléfono y escanea el código QR para autenticarte",
      "error": "Error al generar el código QR",
      "expired": "El código QR ha expirado. Por favor, intenta de nuevo."
    }
  },
  "olorin": {
    "errors": {
      "session_not_found": "Sesión no encontrada",
      "session_different_partner": "La sesión pertenece a otro socio",
      "session_invalid_status": "La sesión está en estado {status}, no se puede agregar transcripción",
      "max_sessions_reached": "Se alcanzó el número máximo de sesiones simultáneas ({limit})",
      "invalid_api_key": "Clave API inválida",
      "missing_api_key": "Falta el encabezado {header}",
      "capability_disabled": "La capacidad '{capability}' está actualmente deshabilitada",
      "capability_not_enabled": "La capacidad '{capability}' no está habilitada para este socio",
      "source_language_not_supported": "El idioma de origen '{language}' no es compatible. Compatible: {supported}",
      "target_language_not_supported": "El idioma de destino '{language}' no es compatible. Compatible: {supported}",
      "partner_not_found": "Socio no encontrado",
      "partner_registration_failed": "Error al registrar socio",
      "no_updates_provided": "No se proporcionaron actualizaciones",
      "webhook_config_failed": "Error al configurar webhook",
      "webhook_url_not_configured": "URL del webhook no configurada",
      "webhook_secret_not_configured": "Secreto del webhook no configurado",
      "search_failed": "La búsqueda falló",
      "indexing_failed": "La indexación falló",
      "detection_failed": "La detección falló",
      "explanation_failed": "Error al obtener explicación",
      "reference_not_found": "Referencia '{reference_id}' no encontrada",
      "enrichment_failed": "El enriquecimiento falló",
      "get_references_failed": "Error al obtener referencias",
      "create_session_failed": "Error al crear sesión",
      "add_transcript_failed": "Error al agregar transcripción",
      "generate_recap_failed": "Error al generar resumen"
    }
  },
  "portal": {
    "nav": {
      "home": "Inicio",
      "features": "Características",
      "solutions": "Soluciones",
      "pricing": "Precios",
      "demo": "Demo en Vivo",
      "contact": "Contacto",
      "getStarted": "Comenzar"
    },
    "hero": {
      "ctaExplore": "Explorar Características",
      "ctaDemo": "Solicitar Demo"
    },
    "cta": {
      "title": "¿Listo para Comenzar?",
      "subtitle": "Hablemos sobre cómo podemos ayudar a transformar su negocio",
      "button": "Contáctenos"
    },
    "contactPage": {
      "title": "Póngase en Contacto",
      "subtitle": "¿Interesado en nuestras soluciones? Hablemos",
      "formTitle": "Envíenos un Mensaje",
      "infoTitle": "Información de Contacto",
      "form": {
        "name": "Nombre Completo",
        "email": "Correo Electrónico",
        "company": "Nombre de la Empresa",
        "phone": "Número de Teléfono",
        "message": "Su Mensaje",
        "messagePlaceholder": "Cuéntenos sobre sus necesidades..."
      },
      "submit": "Enviar Mensaje",
      "sending": "Enviando...",
      "success": "¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.",
      "error": "Error al enviar el mensaje. Por favor, inténtelo de nuevo.",
      "scheduleTitle": "¿Prefiere Programar una Llamada?",
      "scheduleSubtitle": "Reserve una demo personalizada con nuestro equipo",
      "scheduleCta": "Programar Llamada de Demo"
    },
    "pricingPage": {
      "title": "Asequible",
      "titleHighlight": "Planes de Precios",
      "subtitle": "Elija el plan que se adapte a sus necesidades",
      "comparisonTitle": "Comparación de Características",
      "faqTitle": "Preguntas Frecuentes",
      "faq": {
        "q1": "¿Cómo se calcula el precio?",
        "a1": "El precio se basa en sus necesidades específicas y uso. Contáctenos para un presupuesto personalizado.",
        "q2": "¿Puedo actualizar mi plan más tarde?",
        "a2": "Sí, puede actualizar en cualquier momento. Ayudaremos a migrar sus datos sin problemas.",
        "q3": "¿Qué soporte está incluido?",
        "a3": "Todos los planes incluyen soporte por correo electrónico. Los planes Professional y Enterprise incluyen soporte prioritario con gerentes de cuenta dedicados."
      },
      "professional": {
        "name": "Profesional",
        "price": "Contacte para Presupuesto",
        "priceNote": "Precio personalizado",
        "description": "Para empresas en crecimiento con necesidades avanzadas",
        "cta": "Obtener Presupuesto"
      },
      "enterprise": {
        "name": "Empresarial",
        "price": "Personalizado",
        "priceNote": "Basado en volumen",
        "description": "Para grandes organizaciones e implementaciones empresariales",
        "cta": "Contactar Ventas"
      },
      "ctaTitle": "¿Listo para Comenzar?",
      "ctaSubtitle": "Hablemos sobre sus necesidades y encontremos el plan perfecto",
      "ctaButton": "Contactar Ventas"
    },
    "featuresPage": {
      "title": "Poderosas",
      "titleHighlight": "Características",
      "subtitle": "Todo lo que necesita para tener éxito",
      "techSpecsTitle": "Especificaciones Técnicas",
      "workflowTitle": "Cómo Funciona",
      "workflow": {
        "s1": {
          "title": "Importar",
          "description": "Suba y organice su contenido"
        },
        "s2": {
          "title": "Configurar",
          "description": "Establezca sus preferencias y ajustes"
        },
        "s3": {
          "title": "Implementar",
          "description": "Ponga en marcha su solución"
        },
        "s4": {
          "title": "Monitorear",
          "description": "Rastree el rendimiento y optimice"
        }
      },
      "ctaTitle": "¿Listo para Explorar las Características?",
      "ctaSubtitle": "Vea todas las características en acción con una demo personalizada",
      "ctaButton": "Programar Demo"
    },
    "demoPage": {
      "title": "Vea Nuestra",
      "titleHighlight": "Plataforma",
      "subtitle": "Experimente el poder de nuestra solución",
      "scheduleCta": "Programar Demo en Vivo",
      "stepsTitle": "Cómo Funciona",
      "steps": {
        "analyze": {
          "title": "Analizar",
          "description": "Rastree y mejore el rendimiento"
        }
      },
      "featuresTitle": "Aspectos Destacados de la Plataforma",
      "platformsTitle": "Disponible En",
      "ctaTitle": "¿Listo para Su Demo Personalizada?",
      "ctaSubtitle": "Programe una demostración personalizada adaptada a sus necesidades",
      "ctaButton": "Programar Demo"
    },
    "workflow": {
      "sectionTitle": "Flujo de Trabajo Inteligente",
      "sectionSubtitle": "Proceso optimizado en 4 pasos",
      "step1": {
        "title": "Configurar",
        "description": "Configure su cuenta y preferencias"
      },
      "step2": {
        "title": "Personalizar",
        "description": "Personalice ajustes para sus necesidades"
      },
      "step3": {
        "title": "Implementar",
        "description": "Lance su solución"
      },
      "step4": {
        "title": "Monitorear",
        "description": "Rastree el rendimiento y optimice"
      }
    }
  },
  "trivia": {
    "didYouKnow": "¿Sabías Que?",
    "dismissHint": "Descartar dato curioso",
    "settings": {
      "displayLanguages": "Idiomas de Visualización",
      "languageHint": "Selecciona 1-3 idiomas para mostrar en cada dato",
      "language": "idioma",
      "selectLanguage": "Seleccionar este idioma",
      "deselectLanguage": "Deseleccionar este idioma",
      "enableDescription": "Mostrar preguntas de trivia mientras ves contenido.",
      "enableTrivia": "Activar trivia",
      "title": "Ajustes de trivia"
    },
    "aiTrivia": "Trivia IA",
    "tellMeMore": "Cuentame mas",
    "more": "Más",
    "follow_up": "Seguimiento"
  },
  "auth": {
    "loginRequired": "Inicio de sesión requerido",
    "loginToWatch": "Por favor inicia sesión para ver {{title}}",
    "login": "Iniciar sesión",
    "signUp": "Registrarse",
    "biometricEnrollEnable": "Activar",
    "biometricEnrollMessage": "Usa Face ID o huella digital para iniciar sesion mas rapido.",
    "biometricEnrollSkip": "Omitir",
    "biometricEnrollTitle": "Activar inicio biometrico",
    "biometricSignIn": "Iniciar con biometria",
    "signOut": "Cerrar sesion",
    "register": {
      "createAccount": "Crear cuenta",
      "email": "Correo electronico",
      "password": "Contrasena",
      "confirmPassword": "Confirmar contrasena",
      "register": "Registrarse",
      "alreadyHaveAccount": "Ya tienes una cuenta? Inicia sesion",
      "passwordStrength": {
        "weak": "Debil",
        "medium": "Media",
        "strong": "Fuerte"
      }
    }
  },
  "recording": {
    "stop": "Detener Grabación",
    "start": "Iniciar Grabación"
  },
  "discover": {
    "title": "Descubrir",
    "subtitle": "Explora 19 funciones impulsadas por IA",
    "description": "Bayit+ utiliza IA para mejorar tu experiencia de visualización, escucha y aprendizaje. Descubre lo que está disponible en tu plataforma.",
    "featureCount": "{{count}} funciones",
    "tryIt": "Probar",
    "startWalkthrough": "Iniciar recorrido",
    "availableOn": "Disponible en",
    "prerequisites": "Requisitos previos",
    "setup": "Configurar",
    "error": {
      "fetchFailed": "Error al cargar las funciones de Discover. Por favor, inténtalo de nuevo.",
      "unknownFeature": "Función no encontrada.",
      "featureDisabled": "Esta función está actualmente desactivada."
    },
    "availability": {
      "ready": "Listo",
      "setupNeeded": "Configuración necesaria",
      "premiumRequired": "Se requiere Premium",
      "notAvailable": "No disponible",
      "platformOnly": "Otra plataforma"
    },
    "platform": {
      "web": "Web",
      "ios": "iOS",
      "android": "Android",
      "tvos": "Apple TV"
    },
    "category": {
      "watching_movies": "Ver películas",
      "watching_live_tv": "Ver TV en vivo",
      "learn_hebrew": "Aprender hebreo",
      "search_discovery": "Búsqueda y descubrimiento",
      "chat_assistants": "Asistentes de chat"
    },
    "feature": {
      "pause_ask": {
        "name": "Pausar y Preguntar",
        "tagline": "Pausa cualquier escena y pregúntale a tu compañero de IA al respecto",
        "description": "Mientras ves, pausa el video y haz preguntas sobre la escena actual. Tu personaje de IA explicará referencias culturales, traducirá diálogos o discutirá la trama."
      },
      "interactive_subtitles": {
        "name": "Subtítulos interactivos",
        "tagline": "Toca cualquier palabra de los subtítulos para obtener traducción y contexto instantáneos",
        "description": "Haz clic en cualquier palabra de los subtítulos para ver su traducción, escuchar la pronunciación y obtener ejemplos de uso. Amplía tu vocabulario mientras ves tus programas favoritos."
      },
      "vocabulary": {
        "name": "Constructor de vocabulario",
        "tagline": "Aprende palabras nuevas de los programas que ves",
        "description": "Recopila automáticamente nuevas palabras hebreas de los subtítulos. Repasa tarjetas de memoria, sigue tu progreso y amplía tu vocabulario a través del contenido que disfrutas."
      },
      "vod_moments": {
        "name": "Momentos VOD",
        "tagline": "Momentos destacados seleccionados por IA de tu contenido favorito",
        "description": "Obtén clips de momentos destacados y puntos clave generados por IA de películas y programas. Comparte escenas memorables y revive los mejores momentos."
      },
      "cultural_context": {
        "name": "Contexto cultural",
        "tagline": "Comprende el trasfondo cultural detrás de cada escena",
        "description": "Recibe anotaciones culturales en tiempo real que explican costumbres israelíes, festividades, humor y normas sociales que aparecen en el contenido que ves."
      },
      "bilingual_bridge": {
        "name": "Puente bilingüe",
        "tagline": "Aprendizaje hebreo-español en paralelo mientras ves",
        "description": "Visualiza subtítulos en dos idiomas con vocabulario resaltado. Alterna entre el hebreo y tu idioma nativo para desarrollar la comprensión de forma natural."
      },
      "ai_companion": {
        "name": "Compañero de IA",
        "tagline": "Tu guía personal de IA para el contenido israelí",
        "description": "Un personaje de IA que ve contigo, ofreciendo comentarios, respondiendo preguntas y ayudándote a entender los matices de los medios israelíes."
      },
      "live_dubbing": {
        "name": "Doblaje en vivo",
        "tagline": "Doblaje por IA en tiempo real de canales israelíes en vivo",
        "description": "Mira la TV israelí en vivo con doblaje en tiempo real impulsado por IA en tu idioma preferido. Disfruta de noticias, programas de entrevistas y entretenimiento sin barreras idiomáticas."
      },
      "live_subtitles": {
        "name": "Subtítulos en vivo",
        "tagline": "Subtítulos por IA en tiempo real para transmisiones en vivo",
        "description": "Obtén subtítulos generados por IA en tiempo real mientras ves la TV israelí en vivo. Elige tu idioma preferido para la traducción instantánea del contenido en vivo."
      },
      "live_trivia": {
        "name": "Trivia en vivo",
        "tagline": "Juega trivias basadas en lo que se emite en vivo",
        "description": "La IA detecta temas de las transmisiones en vivo y genera preguntas de trivia en tiempo real. Compite con amigos y aprende sobre la cultura israelí mientras ves TV."
      },
      "catch_up": {
        "name": "Ponte al día",
        "tagline": "Resúmenes de IA de lo que te perdiste en TV en vivo",
        "description": "¿Te perdiste parte de una transmisión en vivo? Obtén resúmenes generados por IA que te ponen al día con lo que sucedió, con los momentos clave destacados para una revisión rápida."
      },
      "scene_search": {
        "name": "Búsqueda de escenas",
        "tagline": "Busca escenas específicas en todo el contenido",
        "description": "Describe una escena que recuerdes y la IA la encontrará en todo el contenido disponible. Busca por diálogo, elementos visuales o descripciones de la trama."
      },
      "phonetic_mirror": {
        "name": "Espejo fonético",
        "tagline": "Practica la pronunciación del hebreo con retroalimentación de IA",
        "description": "Grábate hablando hebreo y recibe retroalimentación instantánea de IA sobre tu pronunciación. Compara tu habla con hablantes nativos y sigue tu mejora a lo largo del tiempo."
      },
      "talk_back": {
        "name": "Responder",
        "tagline": "Ten conversaciones de voz en hebreo con tu personaje de IA",
        "description": "Practica el hebreo conversacional hablando con tu personaje de IA. Recibe retroalimentación en tiempo real sobre gramática, vocabulario y pronunciación en un diálogo natural."
      },
      "interactive_mission": {
        "name": "Misiones interactivas",
        "tagline": "Divertidos desafíos de aprendizaje del hebreo con guía de IA",
        "description": "Completa misiones guiadas por IA que combinan ver contenido con ejercicios de aprendizaje del hebreo. Gana recompensas y sigue tu viaje lingüístico."
      },
      "glossary": {
        "name": "Glosario personal",
        "tagline": "Tu diccionario hebreo personalizado construido a partir del contenido",
        "description": "Todas las palabras hebreas que has encontrado y guardado, organizadas por categoría, frecuencia y nivel de dominio. Repasa y practica en cualquier momento."
      },
      "llm_search": {
        "name": "Búsqueda con IA",
        "tagline": "Encuentra contenido con consultas en lenguaje natural",
        "description": "Busca en toda la biblioteca de Bayit+ usando lenguaje natural. Pide 'comedias israelíes divertidas sobre familias' o 'documentales sobre Tel Aviv' y obtén resultados seleccionados por IA."
      },
      "proactive_voice": {
        "name": "Voz proactiva",
        "tagline": "Asistente de IA por voz que anticipa tus necesidades",
        "description": "Un asistente de IA que escucha y proactivamente ofrece sugerencias de contenido relevante, traducciones y oportunidades de aprendizaje según lo que estás viendo."
      },
      "chatbot": {
        "name": "Chat Bayit",
        "tagline": "Chatea con IA sobre cualquier cosa relacionada con el contenido israelí",
        "description": "Haz preguntas sobre la cultura israelí, obtén recomendaciones de contenido, practica hebreo o comenta lo que has visto. Tu compañero de IA siempre está disponible."
      }
    },
    "prereq": {
      "avatar": "Crea tu personaje de IA",
      "subscription": "Se requiere suscripción Premium",
      "microphone": "Se necesita acceso al micrófono",
      "contentType": "Selecciona tus preferencias de contenido",
      "preference": "Configura tus preferencias de idioma",
      "voiceClone": "Configura tu clon de voz"
    },
    "walkthrough": {
      "tryItNow": "Probar ahora",
      "watchDemo": "Ver demo",
      "skip": "Omitir",
      "next": "Siguiente",
      "done": "Listo",
      "complete": "Tutorial completado",
      "stepCounter": "{{current}} de {{total}}",
      "pause_ask": {
        "step1": "Navega a una pelicula con momentos interactivos",
        "step2": "Pausa la pelicula durante una escena",
        "step3": "Toca el boton Preguntar al personaje",
        "step4": "Observa la respuesta del personaje"
      },
      "interactive_subtitles": {
        "step1": "Comienza a reproducir una pelicula con subtitulos",
        "step2": "Toca el boton Interactivo en la barra de control",
        "step3": "Selecciona tu idioma de subtitulos",
        "step4": "Toca cualquier palabra en los subtitulos para aprender mas"
      },
      "vocabulary": {
        "step1": "Abre una pelicula con subtitulos interactivos",
        "step2": "Toca una palabra que quieras aprender",
        "step3": "Toca Guardar en vocabulario",
        "step4": "Revisa tus palabras guardadas en la seccion Vocabulario"
      },
      "vod_moments": {
        "step1": "Comienza a ver una pelicula con momentos interactivos",
        "step2": "Espera a que aparezca un aviso interactivo",
        "step3": "Ve la interaccion generada por IA"
      },
      "cultural_context": {
        "step1": "Reproduce una pelicula con dialogo en hebreo",
        "step2": "Toca un subtitulo con significado cultural",
        "step3": "Lee la explicacion cultural generada por IA"
      },
      "bilingual_bridge": {
        "step1": "Abre una pelicula con soporte bilingue",
        "step2": "Selecciona el modo de subtitulos bilingue",
        "step3": "Toca una frase resaltada para ver la traduccion",
        "step4": "Ve ambos idiomas uno al lado del otro"
      },
      "ai_companion": {
        "step1": "Comienza a ver cualquier pelicula",
        "step2": "Toca el boton Companero IA",
        "step3": "Escribe una pregunta sobre la pelicula",
        "step4": "Lee la respuesta contextual de la IA"
      },
      "live_dubbing": {
        "step1": "Navega a un canal de TV en vivo",
        "step2": "Toca el boton de doblaje en la barra de control",
        "step3": "Selecciona tu idioma preferido",
        "step4": "Escucha el doblaje IA en tiempo real"
      },
      "live_subtitles": {
        "step1": "Navega a un canal de TV en vivo",
        "step2": "Toca el boton de subtitulos",
        "step3": "Selecciona tu idioma de subtitulos",
        "step4": "Ve los subtitulos en tiempo real"
      },
      "live_trivia": {
        "step1": "Navega a un canal de TV en vivo",
        "step2": "Toca el boton de trivia",
        "step3": "Responde las preguntas generadas por IA"
      },
      "catch_up": {
        "step1": "Navega a una transmision en vivo",
        "step2": "Selecciona la opcion de ponerse al dia",
        "step3": "Toca para generar un resumen IA",
        "step4": "Lee el resumen de lo que te perdiste"
      },
      "scene_search": {
        "step1": "Navega a una transmision grabada",
        "step2": "Escribe lo que estas buscando",
        "step3": "Toca la escena correspondiente",
        "step4": "Ve la escena desde ese punto"
      },
      "phonetic_mirror": {
        "step1": "Abre el Espejo Fonetico en Zeh Ani",
        "step2": "Lee la frase en hebreo mostrada",
        "step3": "Di la frase en tu microfono",
        "step4": "Revisa los comentarios de pronunciacion de la IA"
      },
      "talk_back": {
        "step1": "Abre Talk Back en Zeh Ani",
        "step2": "Escucha a tu avatar hablar hebreo",
        "step3": "Responde en hebreo usando tu microfono",
        "step4": "Revisa los comentarios de la IA"
      },
      "interactive_mission": {
        "step1": "Abre Misiones Interactivas",
        "step2": "Selecciona un nivel de mision",
        "step3": "Sigue los ejercicios guiados por IA",
        "step4": "Completa la mision y gana recompensas"
      },
      "glossary": {
        "step1": "Abre el Glosario de Hebreo",
        "step2": "Busca una palabra en hebreo",
        "step3": "Escucha la pronunciacion"
      },
      "llm_search": {
        "step1": "Abre la pestana de Busqueda",
        "step2": "Escribe una consulta en lenguaje natural",
        "step3": "Explora los resultados seleccionados por IA"
      },
      "proactive_voice": {
        "step1": "Abre la funcion de Sugerencias de Voz",
        "step2": "Mantene presionado para hablar",
        "step3": "Escucha las recomendaciones personalizadas"
      },
      "chatbot": {
        "step1": "Abre el Asistente IA",
        "step2": "Escribe tu pregunta o solicitud",
        "step3": "Lee la respuesta de la IA"
      }
    }
  },
  "byoc": {
    "home": {
      "title": "Trae tu propio contenido",
      "subtitle": "Conecta tus fuentes IPTV, Plex o YouTube y disfruta de las funciones de IA de Bayit+ en tu propio contenido",
      "connectButton": "Conectar fuentes",
      "aiFeatures": {
        "dubbing": "Doblaje IA disponible",
        "subtitles": "Subtitulos en vivo disponibles"
      }
    },
    "pageSubtitle": "Trae tu propio contenido - añade fuentes IPTV y de streaming",
    "addSource": "Agregar fuente",
    "sync": "Sincronizar",
    "remove": "Eliminar",
    "channelCount": "{{count}} canales",
    "empty": {
      "title": "No se han añadido fuentes",
      "subtitle": "Añade tus fuentes IPTV, Xtream o de streaming para ver tu propio contenido junto a Bayit+"
    },
    "source": {
      "iptv": "Fuente IPTV",
      "xtream": "Xtream Codes"
    },
    "sourceType": {
      "iptv": "IPTV / M3U",
      "xtream": "Xtream Codes"
    },
    "addIptv": {
      "title": "Agregar fuente IPTV",
      "subtitle": "Introduce una URL a un archivo de lista de reproducción M3U o M3U8",
      "urlPlaceholder": "https://example.com/playlist.m3u",
      "validate": "Validar",
      "add": "Agregar fuente"
    },
    "addXtream": {
      "title": "Conectar Xtream Codes",
      "subtitle": "Introduce las credenciales de tu servidor Xtream Codes",
      "serverUrl": "URL del servidor",
      "username": "Nombre de usuario",
      "password": "Contraseña",
      "connect": "Conectar"
    },
    "preview": {
      "title": "Vista previa",
      "channelCount": "{{count}} canales encontrados"
    },
    "providers": {
      "title": "Proveedores populares"
    },
    "wizard": {
      "step1": "Agregar fuente",
      "step2": "Procesando",
      "step3": "Revisión",
      "selectSource": "Seleccionar tipo de fuente"
    },
    "normalization": {
      "title": "Procesando tu contenido",
      "total": "{{count}} canales en total",
      "matched": "{{count}} coincidencias",
      "stage": {
        "parsing": "Analizando lista de reproducción...",
        "matching": "Buscando coincidencias de canales...",
        "enriching": "Enriqueciendo metadatos...",
        "finalizing": "Finalizando..."
      }
    },
    "review": {
      "title": "Revisar contenido importado",
      "subtitle": "{{matched}} coincidencias, {{unmatched}} canales sin coincidencia",
      "matchedChannels": "Canales coincidentes",
      "unmatchedChannels": "Canales sin coincidencia",
      "apply": "Aplicar e importar"
    },
    "error": {
      "urlRequired": "Por favor, introduce una URL",
      "noChannels": "No se encontraron canales en esta lista de reproducción",
      "invalidUrl": "No se pudo cargar la lista de reproducción desde esta URL",
      "allFieldsRequired": "Todos los campos son obligatorios",
      "enrichFailed": "Error al analizar la fuente",
      "syncFailed": "Error al sincronizar la fuente",
      "normalizationFailed": "El procesamiento del contenido falló",
      "normalizationPollFailed": "Se perdió la conexión durante el procesamiento"
    },
    "plex": {
      "connectPlex": "Conectar Plex",
      "enterCodeAt": "Ingresa este codigo en",
      "waitingForAuth": "Esperando autorizacion...",
      "selectServer": "Selecciona un servidor Plex",
      "connecting": "Conectando a {{serverName}}...",
      "connected": "Conectado",
      "label": "Plex"
    },
    "settings": {
      "title": "Tus fuentes de contenido",
      "refresh": "Actualizar",
      "noSources": "No hay fuentes de contenido conectadas",
      "noSourcesSubtitle": "Conecta tu Plex, YouTube, IPTV o proveedor Xtream",
      "removeSource": "Eliminar fuente",
      "plexSubtitle": "Transmite desde tu servidor de medios Plex",
      "youtubeSubtitle": "Accede a tu biblioteca de YouTube",
      "iptvXtreamLabel": "IPTV / Xtream",
      "iptvXtreamSubtitle": "Agrega una lista M3U o codigos Xtream",
      "youtube": "YouTube",
      "xtreamCodes": "Xtream Codes",
      "iptv": "IPTV"
    }
  },
  "onboarding": {
    "welcome": {
      "title": "Bienvenido a Bayit+",
      "subtitle": "Tu puerta de entrada impulsada por IA al contenido israelí, la cultura y el aprendizaje del idioma",
      "getStarted": "Comenzar"
    },
    "highlight": {
      "dubbing": "Doblaje IA en vivo",
      "subtitles": "Subtítulos interactivos",
      "ai": "Compañeros IA",
      "learning": "Aprendizaje del hebreo"
    },
    "voice": {
      "title": "Configuración de voz",
      "subtitle": "Activa tu micrófono para comandos de voz, práctica de pronunciación en hebreo y navegación manos libres",
      "enable": "Activar micrófono",
      "granted": "Micrófono activado correctamente"
    },
    "tour": {
      "done": "Listo"
    },
    "demo": {
      "dubbing": {
        "title": "Doblaje IA en vivo",
        "description": "Ve televisión israelí con doblaje IA en tiempo real en tu idioma preferido",
        "hebrew": "Hebreo",
        "english": "Inglés"
      },
      "subtitles": {
        "title": "Subtítulos interactivos",
        "description": "Toca cualquier palabra en los subtítulos para traducción y pronunciación instantáneas",
        "sample": "La familia se reunió para la cena de Shabbat",
        "word": "Shabat",
        "translation": "Shabat - día semanal de descanso"
      },
      "interaction": {
        "title": "Interacción con personaje IA",
        "description": "Pausa cualquier escena y pregunta a tu compañero IA sobre el contexto cultural",
        "userMsg": "¿Qué festividad están celebrando?",
        "aiMsg": "Están celebrando Sukkot, la Fiesta de los Tabernáculos. La cabaña temporal que ves se llama sucá."
      },
      "trivia": {
        "title": "Trivia en vivo",
        "description": "La IA genera preguntas de trivia de lo que se emite en vivo. ¡Compite y aprende!",
        "question": "¿Cuál es el idioma oficial de Israel?",
        "optionA": "Árabe",
        "optionB": "Hebreo",
        "optionC": "Inglés"
      },
      "catchup": {
        "title": "Puesta al día inteligente",
        "description": "¿Perdiste parte de una transmisión en vivo? La IA resume lo que te perdiste",
        "missed": "Perdido",
        "summary": "Resumen IA",
        "live": "En vivo"
      },
      "byoc": {
        "title": "Trae tu propio contenido",
        "description": "Importa tus fuentes IPTV y míralas junto al contenido de Bayit+",
        "step1": "Agregar fuente",
        "step2": "Enriquecimiento IA",
        "step3": "Ver"
      },
      "zehAni": {
        "title": "Crea tu personaje IA",
        "description": "Genera un avatar IA personalizado que aprende contigo",
        "generated": "Avatar IA"
      }
    }
  },
  "dm": {
    "title": "Mensajes",
    "conversations": "Conversaciones",
    "conversation": "Conversación",
    "empty": {
      "title": "Sin mensajes aún",
      "subtitle": "Inicia una conversación con un amigo"
    },
    "input": {
      "placeholder": "Escribe un mensaje...",
      "send": "Enviar"
    },
    "translate": "Traducir",
    "react": "Reaccionar",
    "read": "Leído",
    "sent": "Enviado",
    "loadMore": "Cargar mensajes anteriores",
    "startConversation": "Envía un mensaje para iniciar la conversación",
    "reaction": {
      "like": "Me gusta",
      "love": "Me encanta",
      "laugh": "Jaja",
      "surprise": "Vaya",
      "sad": "Triste"
    },
    "error": {
      "fetchFailed": "Error al cargar los mensajes",
      "sendFailed": "Error al enviar el mensaje"
    }
  },
  "household": {
    "empty": {
      "title": "Sin hogar aún",
      "subtitle": "Crea un hogar para gestionar tu familia"
    },
    "create": {
      "namePlaceholder": "Nombre del hogar",
      "button": "Crear hogar"
    },
    "members": "Miembros",
    "role": {
      "owner": "Propietario",
      "guardian": "Tutor",
      "child": "Hijo"
    },
    "invite": {
      "title": "Invitar miembros",
      "emailPlaceholder": "Correo electrónico",
      "send": "Enviar invitación",
      "pending": "Invitaciones pendientes"
    },
    "removeMember": "Eliminar",
    "error": {
      "fetchFailed": "Error al cargar el hogar",
      "createFailed": "Error al crear el hogar",
      "updateFailed": "Error al actualizar el hogar",
      "deleteFailed": "Error al eliminar el hogar",
      "inviteFailed": "Error al enviar la invitación",
      "removeFailed": "Error al eliminar el miembro"
    }
  },
  "aiChat": {
    "retryButton": "Reintentar",
    "sendButton": "Enviar",
    "title": "Chat IA",
    "voiceButton": "Voz"
  },
  "aiOnboarding": {
    "buttons": {
      "back": "Atras"
    },
    "completion": {
      "message": "Todo listo! Comienza a explorar las funciones de IA.",
      "title": "Configuracion completada"
    },
    "permissions": {
      "description": "Otorga permisos para habilitar funciones de IA como voz y camara.",
      "title": "Permisos"
    },
    "personalization": {
      "description": "Cuentanos tus preferencias para personalizar tu experiencia de IA.",
      "title": "Personalizacion"
    },
    "title": "Configuracion de IA",
    "welcome": {
      "description": "Bayit+ usa IA para mejorar tu experiencia con doblaje, subtitulos y mas.",
      "title": "Bienvenido a Bayit+ IA"
    }
  },
  "auth_device_authorized": "Dispositivo autorizado",
  "auth_device_code_expired": "Codigo expirado",
  "auth_device_get_new_code": "Obtener nuevo codigo",
  "auth_device_manual_login": "Iniciar sesion manualmente",
  "auth_device_visit_uri": "Visita la URL mostrada en tu TV",
  "avatar": {
    "tapToSpeak": "Toca para hablar",
    "title": "Avatar"
  },
  "dubbing": {
    "mixer": {
      "dubbedAudio": "Audio doblado",
      "originalAudio": "Audio original",
      "title": "Mezclador de audio"
    },
    "settings_title": "Ajustes de doblaje",
    "target_language": "Idioma destino",
    "voiceSelector": {
      "selected": "Seleccionado",
      "subtitle": "Elige una voz para el doblaje",
      "title": "Seleccion de voz"
    }
  },
  "go_back": "Volver",
  "miniPlayer": {
    "closePlayer": "Cerrar reproductor",
    "skipBackward": "Retroceder",
    "skipForward": "Avanzar"
  },
  "retry": "Reintentar",
  "search_hint": "Buscar canales, peliculas, series...",
  "search_no_results": "No se encontraron resultados",
  "search_prompt": "Que estas buscando?",
  "subscription_required": "Suscripcion requerida",
  "subscription_upsell_tv": "Actualiza para ver en TV",
  "talkback": {
    "title": "Comentarios"
  },
  "voiceAssistant": {
    "fabLabel": "Asistente de voz",
    "modal": {
      "cancel": "Cancelar",
      "setupMessage": "Configura el reconocimiento de voz para usar el asistente.",
      "setupRequired": "Configuracion requerida",
      "startSetup": "Iniciar configuracion",
      "title": "Asistente de voz"
    }
  },
  "voiceCommand": {
    "executing": "Ejecutando...",
    "listening": "Escuchando...",
    "noMatch": "Sin coincidencia",
    "recognized": "Reconocido"
  },
  "voiceDecision": {
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "matched": "Coincidencia"
  },
  "voiceSearch": {
    "listening": "Escuchando...",
    "noResults": "Sin resultados",
    "tapToSpeak": "Toca para hablar",
    "title": "Busqueda por voz"
  },
  "voiceSettings": {
    "language": "Idioma",
    "speechRate": "Velocidad de habla",
    "title": "Ajustes de voz",
    "ttsProvider": "Proveedor TTS",
    "voiceMode": "Modo de voz",
    "voiceSelection": "Seleccion de voz",
    "wakeWord": "Palabra de activacion"
  },
  "voiceWizard": {
    "buttons": {
      "back": "Atras"
    },
    "calibration": {
      "description": "Habla normalmente para calibrar el microfono.",
      "listening": "Escuchando...",
      "micButton": "Iniciar grabacion",
      "resultTitle": "Resultado de calibracion",
      "stopButton": "Detener grabacion",
      "tapToStart": "Toca para iniciar calibracion",
      "title": "Calibracion de microfono"
    },
    "complete": {
      "message": "La configuracion del asistente de voz esta completa.",
      "title": "Configuracion completada"
    },
    "language": {
      "description": "Selecciona tu idioma preferido para comandos de voz.",
      "title": "Idioma de voz"
    },
    "permission": {
      "description": "Se necesita acceso al microfono para funciones de voz.",
      "granted": "Permiso otorgado",
      "requestButton": "Otorgar permiso",
      "title": "Permiso de microfono"
    },
    "title": "Asistente de configuracion de voz"
  },
  "watch_now": "Ver ahora",
  "culture": {
    "title": "Cultura israelí",
    "description": "Jerusalén, Tel Aviv y herencia israelí",
    "shabbat": {
      "title": "Modo Shabat",
      "enableShabbatMode": "Habilitar modo Shabat",
      "shabbatTimes": "Horarios de Shabat",
      "timesDescription": "Los horarios de encendido de velas y Havdalá se mostrarán aquí",
      "aboutTitle": "Acerca del modo Shabat",
      "aboutDescription": "Cuando está habilitado, el modo Shabat pausará las notificaciones, reducirá el brillo de la pantalla y habilitará una interfaz simplificada durante las horas de Shabat."
    },
    "judaism": {
      "holidaysAndTorah": "Festividades y Torá",
      "parashaOfTheWeek": "Parashá de la semana",
      "parashaDescription": "Lectura semanal de la Torá y comentario"
    },
    "morning": {
      "title": "Ritual matutino",
      "description": "Comienza tu día con intención y gratitud",
      "dailyInspiration": "Inspiración diaria",
      "dailyInspirationDescription": "Contenido seleccionado para tu rutina matutina",
      "modehAni": "Modé Aní",
      "modehAniDescription": "Oración de gratitud matutina",
      "netilatYadayim": "Netilat Yadayim",
      "netilatYadayimDescription": "Lavado ritual de manos",
      "shacharit": "Shajarit",
      "shacharitDescription": "Servicio de oración matutina"
    },
    "glossary": {
      "termDetail": "Detalle del término",
      "definition": "Definición",
      "pronunciation": "Pronunciación",
      "examples": "Ejemplos"
    },
    "jerusalem": {
      "title": "Jerusalén"
    },
    "telaviv": {
      "title": "Tel Aviv"
    }
  },
  "zehAni": {
    "dashboard": {
      "title": "Zeh Ani",
      "biometricConsent": "Consentimiento biométrico",
      "activeConsents": "{{count}} consentimientos activos",
      "magicMirror": "Espejo mágico",
      "magicMirrorDescription": "Saludos diarios e identificación facial",
      "v2vPractice": "Práctica V2V",
      "v2vPracticeDescription": "Pronunciación de voz a voz",
      "avatar3d": "Avatar 3D",
      "avatar3dDescription": "Tu malla de avatar personalizada",
      "movieInteractions": "Interacciones con películas",
      "movieInteractionsDescription": "Explora y habla con personajes de películas",
      "contacts": "Contactos",
      "contactsDescription": "Compartir contactos por WhatsApp",
      "feedback": "Comentarios",
      "feedbackDescription": "Comparte tu experiencia",
      "consent": "Consentimiento",
      "consentDescription": "Gestión del consentimiento biométrico",
      "chess": "Ajedrez",
      "chessDescription": "Juega ajedrez con amigos y familia"
    },
    "mirror": {
      "title": "Espejo mágico",
      "avatarContentDescription": "Avatar",
      "wordOfTheDay": "Palabra del día",
      "playLipsync": "Reproducir sincronización labial",
      "noAvatarYet": "Aún no hay avatar",
      "noAvatarDescription": "Crea un avatar 3D para verte en la historia",
      "createAvatar": "Crear avatar"
    },
    "mode": {
      "title": "Modo avatar",
      "enableAvatarMode": "Habilitar modo avatar",
      "enableDescription": "Muestra tu avatar reaccionando al contenido",
      "avatarPreview": "Vista previa del avatar",
      "avatarPreviewContentDescription": "Vista previa del avatar",
      "noAvatarConfigured": "No se configuró un avatar",
      "reactionStyle": "Estilo de reacción"
    },
    "wardrobe": {
      "title": "Guardarropa",
      "equippedContentDescription": "Equipado"
    },
    "settings": {
      "title": "Configuración del avatar",
      "privacy": "Privacidad",
      "privateAvatarMode": "Modo avatar privado",
      "privateAvatarDescription": "Oculta tu avatar de otros usuarios",
      "appearance": "Apariencia",
      "enableAnimations": "Habilitar animaciones",
      "animationsDescription": "Animar movimientos y expresiones del avatar",
      "availableOutfits": "Atuendos disponibles"
    },
    "selfie": {
      "title": "Selfie de video",
      "camera": "Cámara",
      "cameraPreview": "Vista previa de cámara",
      "startRecording": "Iniciar grabación",
      "stopRecording": "Detener grabación",
      "rec": "REC",
      "enterPin": "Ingresa tu PIN para crear un avatar",
      "pinLabel": "PIN",
      "retake": "Volver a tomar",
      "creatingAvatar": "Creando tu avatar...",
      "avatarCreated": "Avatar creado exitosamente",
      "avatarPreviewContentDescription": "Vista previa del avatar",
      "createAnother": "Crear otro"
    },
    "mesh": {
      "title": "Avatar 3D",
      "meshViewer": "Visor de malla 3D",
      "meshViewerDescription": "El visor de malla 3D requiere integración con WebView o GLSurfaceView",
      "skinTone": "Tono de piel",
      "hairStyle": "Peinado",
      "accessories": "Accesorios",
      "saveChanges": "Guardar cambios"
    },
    "v2v": {
      "title": "Práctica de voz",
      "nextPhrase": "Siguiente frase",
      "stop": "Detener",
      "record": "Grabar",
      "mic": "MIC",
      "viewProgress": "Ver progreso",
      "analyzingPronunciation": "Analizando pronunciación...",
      "pronunciationFeedback": "Retroalimentación de pronunciación",
      "similarity": "Similitud: {{score}}%",
      "yourProgress": "Tu progreso",
      "transforms": "Transformaciones: {{count}}",
      "improvement": "Mejora: {{score}}%",
      "continuePracticing": "Seguir practicando"
    },
    "characters": {
      "title": "Personajes",
      "noCharactersFound": "No se encontraron personajes para esta película",
      "characterCount": "{{count}} personajes"
    },
    "interactions": {
      "title": "Interacciones con películas",
      "noInteractableMovies": "No hay películas interactivas disponibles"
    },
    "feedbackInbox": {
      "title": "Bandeja de comentarios",
      "refreshContentDescription": "Actualizar",
      "noFeedbackYet": "Aún no hay comentarios",
      "feedbackAppearHere": "Los comentarios de tus contactos aparecerán aquí",
      "playVoiceMessage": "Reproducir mensaje de voz"
    },
    "addContact": {
      "title": "Agregar contacto",
      "nameLabel": "Nombre",
      "phoneLabel": "Teléfono",
      "relationship": "Relación",
      "language": "Idioma"
    },
    "avatar3d": {
      "title": "Avatar 3D",
      "glbMeshViewer": "Visor de malla GLB",
      "controls": "Controles",
      "animate": "Animar",
      "vertices": "Vértices",
      "bones": "Huesos",
      "blendShapes": "Formas de mezcla",
      "hasGlb": "Tiene GLB",
      "status": "Estado: {{value}}"
    }
  }
}
